(function () {
    'use strict';

    !function(i){"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery);}(function(i){var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0);}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"});},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return !1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e);}),s.$slidesCache=s.$slides,s.reinit();},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed);}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o));},complete:function(){t&&t.call();}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call();},s.options.speed));},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0);});},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t);},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed));},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer);},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e));},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}));},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active");}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"");}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable");},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c));}d.appendChild(a);}o.appendChild(d);}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"});}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l]);}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o];}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition);},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1));},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i));},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault());},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"));}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t]);},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t);},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call();},t.options.speed));},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}));},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit());},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay());},0);});},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e);},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay());},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s});}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"});}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA();},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)));},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1));},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)));},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition);},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show();},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}));},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading");}),n.$slider.trigger("lazyLoaded",[n,e,t]);});},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t]);},r.src=t;});}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow));},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad();},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}});},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition();},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0;},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1;},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()));},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}});},e.prototype.preventDefault=function(i){i.preventDefault();},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad();},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1);},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad());},r.src=o):l.$slider.trigger("allImagesLoaded",[l]);},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1);},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings;}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i});}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e]);},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition();},50));},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return !1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit();},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)));},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e);},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0});}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1});},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e);}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e;});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t]);}l&&(r.unload(),r.reinit());},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i]);},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType;},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center");}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad();},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","");});}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i;},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s);},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o);}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o);}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return !0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s);})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s);}):a.postSlide(s);}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading");},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return !1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1;}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]));}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={});},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i);}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0;},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit());},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","");},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy();},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")));},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"));},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1);},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o};});

    !function(e){var t=e.Element.prototype;"function"!=typeof t.matches&&(t.matches=t.msMatchesSelector||t.mozMatchesSelector||t.webkitMatchesSelector||function(e){for(var t=(this.document||this.ownerDocument).querySelectorAll(e),o=0;t[o]&&t[o]!==this;)++o;return Boolean(t[o])}),"function"!=typeof t.closest&&(t.closest=function(e){for(var t=this;t&&1===t.nodeType;){if(t.matches(e))return t;t=t.parentNode;}return null});}(window);

    (function(x){var g;"undefined"!==typeof window?g=window:"undefined"!==typeof self&&(g=self);g.inViewport=x();})(function(){return function e(g,n,p){function t(k,f){if(!n[k]){if(!g[k]){var l="function"==typeof require&&require;if(!f&&l)return l(k,!0);if(u)return u(k,!0);f=Error("Cannot find module '"+k+"'");throw f.code="MODULE_NOT_FOUND",f;}f=n[k]={exports:{}};g[k][0].call(f.exports,function(e){var f=g[k][1][e];return t(f?f:e)},f,f.exports,e,g,n,p);}return n[k].exports}for(var u="function"==typeof require&&
    require,q=0;q<p.length;q++)t(p[q]);return t}({1:[function(g,n,p){(function(e){function g(b,a,d){b.attachEvent?b.attachEvent("on"+a,d):b.addEventListener(a,d,!1);}function p(b,a,d){var c;return function(){var m=this,e=arguments,f=d&&!c;clearTimeout(c);c=setTimeout(function(){c=null;d||b.apply(m,e);},a);f&&b.apply(m,e);}}function q(b,a,d){function c(a,b,c){return {watch:function(){h.add(a,b,c);},dispose:function(){h.remove(a);}}}function m(a,c){if(!(a&&v(e.document.documentElement,a)&&v(e.document.documentElement,
    b)&&a.offsetWidth&&a.offsetHeight))return !1;var d=a.getBoundingClientRect();if(b===e.document.body){a=-c;var m=-c;var f=e.document.documentElement.clientWidth+c;c=e.document.documentElement.clientHeight+c;}else{var h=b.getBoundingClientRect();a=h.top-c;m=h.left-c;f=h.right+c;c=h.bottom+c;}return d.right>=m&&d.left<=f&&d.bottom>=a&&d.top<=c}var h=k(),w=b===e.document.body?e:b,r=p(h.checkAll(function(a,c,b){m(a,c)&&(h.remove(a),b(a));}),a);g(w,"scroll",r);w===e&&g(e,"resize",r);y&&f(h,b,r);0<d&&setInterval(r,
    d);return {container:b,isInViewport:function(a,b,d){if(!d)return m(a,b);a=c(a,b,d);a.watch();return a},_debounce:a,_failsafe:d}}function k(){function b(a){for(var c=d.length-1;0<=c;c--)if(d[c][0]===a)return c;return -1}function a(a){return -1!==b(a)}var d=[];return {add:function(c,b,e){a(c)||d.push([c,b,e]);},remove:function(a){a=b(a);-1!==a&&d.splice(a,1);},isWatched:a,checkAll:function(a){return function(){for(var b=d.length-1;0<=b;b--)a.apply(this,d[b]);}}}}function f(b,a,d){function c(a){a=g.call([],
    Array.prototype.slice.call(a.addedNodes),a.target);return 0<f.call(a,b.isWatched).length}var e=new MutationObserver(function(a){!0===a.some(c)&&setTimeout(d,0);}),f=Array.prototype.filter,g=Array.prototype.concat;e.observe(a,{childList:!0,subtree:!0,attributes:!0});}n.exports=function(b,a,d){var c=e.document.body;if(void 0===a||"function"===typeof a)d=a,a={};c=a.container||c;var f=a.offset||0,h=a.debounce||15;a=a.failsafe||150;!0===a?a=150:!1===a&&(a=0);0<a&&a<h&&(a=h+50);for(var g=0;g<l.length;g++)if(l[g].container===
    c&&l[g]._debounce===h&&l[g]._failsafe===a)return l[g].isInViewport(b,f,d);return l[l.push(q(c,h,a))-1].isInViewport(b,f,d)};var l=[],y="function"===typeof e.MutationObserver,v=function(){return e.document?e.document.documentElement.compareDocumentPosition?function(b,a){return !!(b.compareDocumentPosition(a)&16)}:e.document.documentElement.contains?function(b,a){return b!==a&&(b.contains?b.contains(a):!1)}:function(b,a){for(;a=a.parentNode;)if(a===b)return !0;return !1}:!0};}).call(this,"undefined"!==
    typeof global?global:"undefined"!==typeof self?self:"undefined"!==typeof window?window:{});},{}]},{},[1])(1)});

    const accordion = {
        accordions: document.querySelectorAll('.accordion'),
        accordionItem: '.accordion__item',
        activeClass: 'accordion__item--active',

        /*
        Initialization on page load
        */
        init()
        {
            this.setup();
        },

        /*
        Sets up the accordions
        */
        setup()
        {
            for(let accordion of this.accordions)
            {
                let accordionTitles = accordion.querySelectorAll('.accordion__title');

                //Loop through accordion titles within this accordion
                for(let accordionTitle of accordionTitles)
                {
                    accordionTitle.addEventListener('click', event =>
                    {
                        //If this accordion item contains the active class, close the item...else open it
                        if(event.currentTarget.closest(this.accordionItem).classList.contains(this.activeClass))
                        {
                            this.close(event);
                        }
                        else
                        {
                            this.open(event);
                        }
                    });
                }
            }
        },

        /*
        Opens an accordion item by adding the active class

        @param {Object} element - the accordion element
        */
        open(element)
        {
            element.currentTarget.closest(this.accordionItem).classList.add(this.activeClass);
            element.currentTarget.setAttribute('aria-expanded', true);
            element.currentTarget.nextElementSibling.setAttribute('aria-hidden', false);
        },

        /*
        Closes an accordion item by removing the active class

        @param {Object} element - the accordion element
        */
        close(element)
        {
            element.currentTarget.closest(this.accordionItem).classList.remove(this.activeClass);
            element.currentTarget.setAttribute('aria-expanded', false);
            element.currentTarget.nextElementSibling.setAttribute('aria-hidden', true);
        }
    };

    var __assign=undefined&&undefined.__assign||function(){return (__assign=Object.assign||function(t){for(var i,n=1,s=arguments.length;n<s;n++)for(var a in i=arguments[n])Object.prototype.hasOwnProperty.call(i,a)&&(t[a]=i[a]);return t}).apply(this,arguments)},CountUp=function(){function t(t,i,n){var s=this;this.endVal=i,this.options=n,this.version="2.4.2",this.defaults={startVal:0,decimalPlaces:0,duration:2,useEasing:!0,useGrouping:!0,useIndianSeparators:!1,smartEasingThreshold:999,smartEasingAmount:333,separator:",",decimal:".",prefix:"",suffix:"",enableScrollSpy:!1,scrollSpyDelay:200,scrollSpyOnce:!1},this.finalEndVal=null,this.useEasing=!0,this.countDown=!1,this.error="",this.startVal=0,this.paused=!0,this.once=!1,this.count=function(t){s.startTime||(s.startTime=t);var i=t-s.startTime;s.remaining=s.duration-i,s.useEasing?s.countDown?s.frameVal=s.startVal-s.easingFn(i,0,s.startVal-s.endVal,s.duration):s.frameVal=s.easingFn(i,s.startVal,s.endVal-s.startVal,s.duration):s.frameVal=s.startVal+(s.endVal-s.startVal)*(i/s.duration);var n=s.countDown?s.frameVal<s.endVal:s.frameVal>s.endVal;s.frameVal=n?s.endVal:s.frameVal,s.frameVal=Number(s.frameVal.toFixed(s.options.decimalPlaces)),s.printValue(s.frameVal),i<s.duration?s.rAF=requestAnimationFrame(s.count):null!==s.finalEndVal?s.update(s.finalEndVal):s.callback&&s.callback();},this.formatNumber=function(t){var i,n,a,e,r=t<0?"-":"";i=Math.abs(t).toFixed(s.options.decimalPlaces);var o=(i+="").split(".");if(n=o[0],a=o.length>1?s.options.decimal+o[1]:"",s.options.useGrouping){e="";for(var l=3,h=0,u=0,p=n.length;u<p;++u)s.options.useIndianSeparators&&4===u&&(l=2,h=1),0!==u&&h%l==0&&(e=s.options.separator+e),h++,e=n[p-u-1]+e;n=e;}return s.options.numerals&&s.options.numerals.length&&(n=n.replace(/[0-9]/g,function(t){return s.options.numerals[+t]}),a=a.replace(/[0-9]/g,function(t){return s.options.numerals[+t]})),r+s.options.prefix+n+a+s.options.suffix},this.easeOutExpo=function(t,i,n,s){return n*(1-Math.pow(2,-10*t/s))*1024/1023+i},this.options=__assign(__assign({},this.defaults),n),this.formattingFn=this.options.formattingFn?this.options.formattingFn:this.formatNumber,this.easingFn=this.options.easingFn?this.options.easingFn:this.easeOutExpo,this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.endVal=this.validateValue(i),this.options.decimalPlaces=Math.max(this.options.decimalPlaces),this.resetDuration(),this.options.separator=String(this.options.separator),this.useEasing=this.options.useEasing,""===this.options.separator&&(this.options.useGrouping=!1),this.el="string"==typeof t?document.getElementById(t):t,this.el?this.printValue(this.startVal):this.error="[CountUp] target is null or undefined","undefined"!=typeof window&&this.options.enableScrollSpy&&(this.error?console.error(this.error,t):(window.onScrollFns=window.onScrollFns||[],window.onScrollFns.push(function(){return s.handleScroll(s)}),window.onscroll=function(){window.onScrollFns.forEach(function(t){return t()});},this.handleScroll(this)));}return t.prototype.handleScroll=function(t){if(t&&window&&!t.once){var i=window.innerHeight+window.scrollY,n=t.el.getBoundingClientRect(),s=n.top+window.pageYOffset,a=n.top+n.height+window.pageYOffset;a<i&&a>window.scrollY&&t.paused?(t.paused=!1,setTimeout(function(){return t.start()},t.options.scrollSpyDelay),t.options.scrollSpyOnce&&(t.once=!0)):(window.scrollY>a||s>i)&&!t.paused&&t.reset();}},t.prototype.determineDirectionAndSmartEasing=function(){var t=this.finalEndVal?this.finalEndVal:this.endVal;this.countDown=this.startVal>t;var i=t-this.startVal;if(Math.abs(i)>this.options.smartEasingThreshold&&this.options.useEasing){this.finalEndVal=t;var n=this.countDown?1:-1;this.endVal=t+n*this.options.smartEasingAmount,this.duration=this.duration/2;}else this.endVal=t,this.finalEndVal=null;null!==this.finalEndVal?this.useEasing=!1:this.useEasing=this.options.useEasing;},t.prototype.start=function(t){this.error||(this.callback=t,this.duration>0?(this.determineDirectionAndSmartEasing(),this.paused=!1,this.rAF=requestAnimationFrame(this.count)):this.printValue(this.endVal));},t.prototype.pauseResume=function(){this.paused?(this.startTime=null,this.duration=this.remaining,this.startVal=this.frameVal,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count)):cancelAnimationFrame(this.rAF),this.paused=!this.paused;},t.prototype.reset=function(){cancelAnimationFrame(this.rAF),this.paused=!0,this.resetDuration(),this.startVal=this.validateValue(this.options.startVal),this.frameVal=this.startVal,this.printValue(this.startVal);},t.prototype.update=function(t){cancelAnimationFrame(this.rAF),this.startTime=null,this.endVal=this.validateValue(t),this.endVal!==this.frameVal&&(this.startVal=this.frameVal,null==this.finalEndVal&&this.resetDuration(),this.finalEndVal=null,this.determineDirectionAndSmartEasing(),this.rAF=requestAnimationFrame(this.count));},t.prototype.printValue=function(t){var i=this.formattingFn(t);this.el&&("INPUT"===this.el.tagName?this.el.value=i:"text"===this.el.tagName||"tspan"===this.el.tagName?this.el.textContent=i:this.el.innerHTML=i);},t.prototype.ensureNumber=function(t){return "number"==typeof t&&!isNaN(t)},t.prototype.validateValue=function(t){var i=Number(t);return this.ensureNumber(i)?i:(this.error="[CountUp] invalid start or end value: ".concat(t),null)},t.prototype.resetDuration=function(){this.startTime=null,this.duration=1e3*Number(this.options.duration),this.remaining=this.duration;},t}();

    const animation = {
        count: 0,
        init: function()
        {
            this.inviewTriggerCountupAnimations('.count-animation-figure');
            this.inviewTriggerAnimation('.inview-trigger-animation-fade-in-up-lg', 'animate__fadeInUpLg');
            this.inviewTriggerAnimation('.inview-trigger-animation-fade-in-up-md', 'animate__fadeInUpMd');
            this.inviewTriggerAnimation('.inview-trigger-animation-fade-in-up-sm', 'animate__fadeInUpSm');
            this.inviewTriggerAnimation('.inview-trigger-animation-fade-in', 'animate__fadeIn');
            this.inviewTriggerAnimation('.inview-trigger-animation-slide-in-right-sm', 'animate__slideInRightSm');
            this.inviewTriggerAnimation('.inview-trigger-animation-slide-up-bottom-sm', 'animate__slideUpBottomSm');
        },

        /*
        Adds the animation class to an element when it's is in viewport

        @param {String} elementIdentifier - the element identifier
        @param {String} classToAdd - the class to add to the element
        */
        inviewTriggerAnimation: function(elementIdentifier, classToAdd)
        {
            let elements = document.querySelectorAll(elementIdentifier),
                i;

            for(i = 0; i < elements.length; i++)
            {
                inViewport(elements[i], { offset: -50 }, function(element)
                {
                    $(element).addClass('animated ' + classToAdd);
                });
            }
        },

        /*
        Adds a count up animation to an element when it's is in viewport

        @param {String} elementIdentifier - the element identifier
        */
        inviewTriggerCountupAnimations: function(elementIdentifier)
        {
            let elements = document.querySelectorAll(elementIdentifier),
                i;

            for(i = 0; i < elements.length; i++)
            {
                inViewport(elements[i], { offset: -150 }, function(element)
                {
                    var countUp = new CountUp(
                        element.querySelector('.count-animation-figure-value'),
                        parseInt(element.querySelector('.count-animation-figure-amount').innerHTML),
                        {
                            duration: 2.5
                        }
                    );

                    countUp.start();
                });
            }
        }
    };

    const carousel = {
        cardsCarousels: document.querySelectorAll('.carousel--cards'),
        cardsCarouselsAlt: document.querySelectorAll('.carousel--cards-alt'),
        contentCarousels: document.querySelectorAll('.carousel--content'),
        heroCarousels: document.querySelectorAll('.hero--carousel'),
        imageCarousels: document.querySelectorAll('.carousel--images'),
        logoCarousels: document.querySelectorAll('.carousel--logos'),
        testimonialCarousels: document.querySelectorAll('.carousel--testimonials'),
        featureCardsCarousel: document.querySelectorAll('.carousel--featured-cards'),

        /*
        Initialization on page load
        */
        init()
        {
            this.setup();
        },

        /*
        Sets up the carousels
        */
        setup()
        {
            for(let carousel of this.contentCarousels)
            {
                $(carousel.querySelector('.carousel__inner')).slick({
                    dots: true,
                    appendDots: carousel.querySelector('.carousel__dots'),
                    arrows: true,
                    appendArrows: carousel.querySelector('.carousel__arrows'),
                    prevArrow: '<button type="button" class="arrow arrow--left slick-arrow--prev"></button>',
                    nextArrow: '<button type="button" class="arrow arrow--right slick-arrow--next"></button>',
                    fade: true,
                    variableWidth: false,
                    slidesToScroll: 1,
                    autoplay: false
                });
            }


            for(let carousel of this.heroCarousels)
            {
                let slideDuration = carousel.getAttribute('data-slide-duration') ? carousel.getAttribute('data-slide-duration') : 5000;

                $(carousel.querySelector('.hero__inner')).slick({
                    dots: false,
                    pauseOnHover: false,
                    pauseOnFocus: false,
                    autoplay: true,
                    autoplaySpeed: slideDuration,
                    arrows: false
                });


                //Change slide on click of pagination item
                for(let paginationItem of carousel.querySelectorAll('.hero__pagination__item'))
                {
                    paginationItem.addEventListener('click', () =>
                    {
                        $(carousel.querySelector('.hero__inner')).slick('slickGoTo', paginationItem.getAttribute('data-slide-number'));
                    });
                }


                //Update active pagination on slide change
                $(carousel.querySelector('.hero__inner')).on('beforeChange', function(event, slick, currentSlide, nextSlide)
                {
                    for(let paginationItem of carousel.querySelectorAll('.hero__pagination__item'))
                    {
                        paginationItem.classList.remove('hero__pagination__item--active');
                    }

                    carousel.querySelector('.hero__pagination__item[data-slide-number="' + nextSlide + '"]').classList.add('hero__pagination__item--active');
                });
            }


            for(let carousel of this.imageCarousels)
            {
                $(carousel.querySelector('.carousel__inner')).slick({
                    dots: false,
                    variableWidth: false,
                    arrows: true,
                    appendArrows: carousel.querySelector('.carousel__arrows'),
                    prevArrow: '<button type="button" class="arrow arrow--left slick-arrow--prev"></button>',
                    nextArrow: '<button type="button" class="arrow arrow--right slick-arrow--next"></button>',
                    autoplay: false
                });
            }


            for(let carousel of this.logoCarousels)
            {
                $(carousel.querySelector('.carousel__inner')).slick({
                    dots: false,
                    variableWidth: false,
                    arrows: true,
                    appendArrows: carousel.querySelector('.carousel__arrows'),
                    prevArrow: '<button type="button" class="arrow arrow--left slick-arrow--prev"></button>',
                    nextArrow: '<button type="button" class="arrow arrow--right slick-arrow--next"></button>',
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    autoplay: true,
                    autoplaySpeed: 3000,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3
                            }
                        },
                        {
                            breakpoint: 700,
                            settings: {
                                slidesToShow: 2
                            }
                        }
                    ]
                });
            }


            for(let carousel of this.testimonialCarousels)
            {
                $(carousel.querySelector('.carousel__inner')).slick({
                    dots: true,
                    appendDots: carousel.querySelector('.carousel__dots'),
                    infinite: true,
                    speed: 500,
                    autoplay: false,
                    arrows: false,
                    fade: true
                });
            }


            for(let carousel of this.cardsCarousels)
            {
                let slidesToShow = carousel.getAttribute('data-cols-per-row') ? Number(carousel.getAttribute('data-cols-per-row')) : 4,
                    dots = carousel.getAttribute('data-carousel-dots') ? Boolean(carousel.getAttribute('data-carousel-dots')) : false;

                $(carousel.querySelector('.carousel__inner')).slick({
                    dots: dots,
                    appendDots: carousel.querySelector('.carousel__dots'),
                    arrows: false,
                    infinite: true,
                    speed: 500,
                    variableWidth: false,
                    fade: false,
                    prevArrow: '<button type="button" class="arrow arrow--left slick-arrow--prev"></button>',
                    nextArrow: '<button type="button" class="arrow arrow--right slick-arrow--next"></button>',
                    slidesToShow: slidesToShow,
                    slidesToScroll: 1,
                    autoplay: false,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                variableWidth: true
                            }
                        },
                        {
                            breakpoint: 700,
                            settings: {
                                slidesToShow: 1,
                                variableWidth: true
                            }
                        }
                    ]
                });
            }


            for(let carousel of this.cardsCarouselsAlt)
            {
                let slidesToShow = carousel.getAttribute('data-cols-per-row') ? Number(carousel.getAttribute('data-cols-per-row')) : 3,
                    repeatCards = carousel.getAttribute('data-repeat-cards') ? true : false;

                $(carousel.querySelector('.carousel__inner')).slick({
                    dots: true,
                    appendDots: carousel.querySelector('.carousel__dots'),
                    arrows: false,
                    infinite: repeatCards,
                    speed: 500,
                    variableWidth: true,
                    fade: false,
                    slidesToShow: slidesToShow,
                    slidesToScroll: 1,
                    autoplay: false,
                    responsive: [
                        {
                            breakpoint: 1025,
                            settings: {
                                slidesToShow: 3,
                                variableWidth: true
                            }
                        },
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 2,
                                variableWidth: true
                            }
                        },
                        {
                            breakpoint: 700,
                            settings: {
                                slidesToShow: 1,
                                variableWidth: true
                            }
                        }
                    ]
                });
            }


            for(let carousel of this.featureCardsCarousel)
            {
                $(carousel.querySelector('.carousel__inner')).slick({
                    dots: true,
                    appendDots: carousel.querySelector('.carousel__dots'),
                    infinite: false,
                    speed: 500,
                    autoplay: false,
                    arrows: false,
                    fade: false
                });
            }
        },

        //Apply Slick carousel to the book a session section cards
        loadBookSessionCarousel: function()
        {
            $(document.getElementById('book-event-card-carousel').querySelector('.carousel__inner')).slick({
                dots: false,
                appendArrows: document.getElementById('book-event-card-carousel').querySelector('.carousel__arrows'),
                infinite: false,
                speed: 500,
                arrows: true,
                variableWidth: false,
                fade: false,
                prevArrow: '<button type="button" class="arrow arrow--left slick-arrow--prev"></button>',
                nextArrow: '<button type="button" class="arrow arrow--right slick-arrow--next"></button>',
                slidesToShow: 3,
                slidesToScroll: 1,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 1023,
                        settings: {
                            variableWidth: true,
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            variableWidth: true,
                            slidesToShow: 1
                        }
                    }
                ]
            });
        },
    };

    const form =
    {
        validatedFormButtons: document.querySelectorAll('.validated-form-button'),
        fieldFailedValidationClass: 'form__field--failed-validation',
        fieldLoadingClass: 'form__field--loading',
        fieldPassedValidationClass: 'form__field--passed-validation',
        checkboxFieldLabelFailedValidationClass: 'checkbox--label--failed-validation',
        checkboxFieldLabelPassedValidationClass: 'checkbox--label--passed-validation',
        radioFieldLabelFailedValidationClass: 'form__field__options--failed-validation',
        fieldRequiredClass: 'form__field-required',
        fieldNoticeActiveClass: 'form__field__notice--active',
        fieldNoticePassedValidationClass: 'form__field__notice--passed-validation',
        fieldParentPassedValidationClass: 'form__item--passed-validation',
        failAlertClass: 'alert--fail',
        spamAlertClass: 'alert--fail--spam',
        successAlertClass: 'alert--success',
        filterSelectFields: document.querySelectorAll('[data-submit-form-onchange]'),
        formFields: document.querySelectorAll('select, input, textarea'),
        typeaheadFields: document.querySelectorAll('.typeahead-field'),
        dateOfBirthFields: document.querySelectorAll('.date-of-birth-field'),
        mailingListsignupForm: document.getElementById('mailing-list-signup-form'),
        sectionedForms: document.querySelectorAll('.form-sectioned'),
        showHideFields: document.querySelectorAll('[data-show-hide-field-id]'),
        radioConditionalContentSections: document.querySelectorAll('.form__conditional-content-fields'),
        giftAidAcceptField: document.getElementById('gift_aid_yes'),
        giftAidRejectField: document.getElementById('gift_aid_no'),
        clonableFieldSections: document.querySelectorAll('.form__clone-section'),
        checkoutHowDidYouHearField: document.getElementById('checkout-how-did-you-hear-field'),
        addressTypeaheadFields: document.querySelectorAll('.address-typeahead-field'),
        arrowKeyPressed: false,
        sendForm: '',

        /*
        Initialization on page load
        */
        init()
        {
            this.setup();
        },

        /*
        Sets up the form methods
        */
        setup()
        {
            // for(let addressTypeaheadField of this.addressTypeaheadFields)
            // {
            //     addressTypeaheadField.querySelector('.address-typeahead-field__input').addEventListener('keyup', (event) =>
            //     {
            //         let geocoder = new google.maps.Geocoder();

            //         geocoder.geocode({address: event.target.value}, (results, status) =>
            //         {
            //             const autocomplete = new google.maps.places.Autocomplete(addressTypeaheadField.querySelector('.address-typeahead-field__input'), {
            //                 fields: ["address_components"]
            //             });

            //             autocomplete.addListener("place_changed", () =>
            //             {                            
            //                 const place = autocomplete.getPlace();

            //                 const address = {
            //                     address_line_1: '',
            //                     address_line_2: '',
            //                     town_city: '',
            //                     borough_county: '',
            //                     postcode: ''
            //                 };
                            
            //                 console.log(place);
            //             });
            //         });
            //     });
            // }


            //Submit validated forms
            for(let validatedFormButton of this.validatedFormButtons)
            {
                validatedFormButton.addEventListener('click', event =>
                {
                    event.preventDefault();

                    let formElement = validatedFormButton.closest('.form') ? validatedFormButton.closest('.form') : (validatedFormButton.parentElement.closest('.form') ? validatedFormButton.parentElement.closest('.form') : '');

                    if(this.validateFormsFields(formElement) === 'success')
                    {
                        //If there's a recaptcha
                        if(formElement.querySelector('.g-recaptcha'))
                        {
                            var response = grecaptcha.getResponse();

                            if(response.length !== 0)
                            {
                                //Hide the recaptcha notice
                                if(validatedFormButton.closest('.form').querySelector('.g-recaptcha-notice'))
                                {
                                    validatedFormButton.closest('.form').querySelector('.g-recaptcha-notice').classList.remove(this.fieldNoticeActiveClass);
                                }

                                let ajaxSubmit = validatedFormButton.getAttribute('data-ajax');
            
                                this.submitForm(validatedFormButton.closest('.form'), ajaxSubmit);                            
                            }
                            else
                            {
                                //Show the recaptcha notice
                                if(validatedFormButton.closest('.form').querySelector('.g-recaptcha-notice'))
                                {
                                    validatedFormButton.closest('.form').querySelector('.g-recaptcha-notice').classList.add(this.fieldNoticeActiveClass);
                                }

                                console.log('The recaptcha was not checked');
                            }
                        }
                        else
                        {
                            let ajaxSubmit = validatedFormButton.getAttribute('data-ajax') ? validatedFormButton.getAttribute('data-ajax') : false;
        
                            this.submitForm(validatedFormButton.closest('.form'), ajaxSubmit);
                        }
                    }
                });
            }


            //Set up typeahead fields
            for(let typeaheadField of this.typeaheadFields)
            {
                let dataUrl = typeaheadField.getAttribute('data-url');
                
                if(dataUrl)
                {
                    typeahead({
                        input: typeaheadField,
                        source: {
                            remote: {
                                url: dataUrl,
                                wildcard: '%QUERY'
                            },
                            identifier: 'name'
                        },
                        display: (selected_item, event) =>
                        {
                            if(document.getElementById(typeaheadField.getAttribute('id') + '-salesforce-id[0]'))
                            {
                                document.getElementById(typeaheadField.getAttribute('id') + '-salesforce-id[0]').value = selected_item.id;
                            }

                            return selected_item.name;
                        },
                        preventSubmit: true
                    });
                }

                //On blur, if the user hasn't selected a typeahead option, remove the custom value they've entered into the input field
                typeaheadField.addEventListener('blur', event =>
                {
                    if(typeaheadField.closest('.typeahead-standalone').querySelector('.tt-list') && !typeaheadField.closest('.typeahead-standalone').querySelector('.tt-list').classList.contains('tt-hide'))
                    {
                        typeaheadField.value = '';   
                    }
                });
            }


            //Submit form on change of select value
            if(this.checkoutHowDidYouHearField)
            {
                this.checkoutHowDidYouHearField.addEventListener('change', event =>
                {
                    if((event.target.value.includes('Other') || event.target.value.includes('Referred by Another Organisation')) && document.getElementById('order-notes-field-wrapper'))
                    {
                        document.getElementById('order-notes-field-wrapper').classList.remove('hidden');
                    }
                    else
                    {
                        document.getElementById('order-notes-field-wrapper').classList.add('hidden');
                    }
                });
            }


            //Submit form on change of select value
            for(let filterSelectField of this.filterSelectFields)
            {
                filterSelectField.querySelector('select').addEventListener('change', event =>
                {
                    filterSelectField.closest('form').submit();
                });
            }


            //Show gift aid text when the user selects to give gift aid
            if(this.giftAidAcceptField && document.getElementById('gift_aid_disclaimer'))
            {
                this.giftAidAcceptField.addEventListener('click', event =>
                {
                    document.getElementById('gift_aid_disclaimer').classList.remove('hidden');
                });
            }


            //Show gift aid text when the user selects to give gift aid
            if(this.giftAidRejectField && document.getElementById('gift_aid_disclaimer'))
            {
                this.giftAidRejectField.addEventListener('click', event =>
                {
                    document.getElementById('gift_aid_disclaimer').classList.add('hidden');
                });
            }

            //Show/hide content conditionally based on selected radio option
            for(let radioConditionalContentSection of this.radioConditionalContentSections)
            {
                for(let radioConditionalContentCheckbox of radioConditionalContentSection.querySelectorAll('input[type=radio'))
                {
                    radioConditionalContentCheckbox.addEventListener('click', event =>
                    {
                        let conditionalContentId = radioConditionalContentCheckbox.getAttribute('data-conditional-content-id');

                        //Hide all conditional content
                        for(let radioConditionalContentSectionContent of radioConditionalContentSection.querySelectorAll('.form__conditional-content-fields__content'))
                        {
                            radioConditionalContentSectionContent.classList.remove('form__conditional-content-fields__content--active');
                        }

                        //Add active class to relevant content
                        if(radioConditionalContentSection.querySelector('#' + conditionalContentId))
                        {
                            radioConditionalContentSection.querySelector('#' + conditionalContentId).classList.add('form__conditional-content-fields__content--active');
                        }
                    });
                }
            }


            //Show the age set when a date is selected in a D.O.B field
            for(let dateOfBirthField of this.dateOfBirthFields)
            {
                dateOfBirthField.addEventListener('change', event =>
                {
                    if(dateOfBirthField.nextSibling === null)
                    {
                        var ageTextElement = document.createElement("div");
                    }
                    else
                    {
                        var ageTextElement = dateOfBirthField.nextSibling;
                    }
                    
                    ageTextElement.classList.add('form__field__notice', 'form__field__notice--plain', 'form__field__notice--active');
                    
                    let todaysDate = new Date(),
                        selectedDate = new Date(event.target.value);
                        
                    todaysDate.toISOString().substring(0,10);

                    if(this.calculateDateDifference(todaysDate, selectedDate))
                    {
                        ageTextElement.classList.remove('hidden');
                        ageTextElement.innerHTML = 'Your child is ' + this.calculateDateDifference(todaysDate, selectedDate) + ' old';
                    }
                    else
                    {
                        ageTextElement.classList.add('hidden');
                    }

                    dateOfBirthField.after(ageTextElement);
                });
            }


            //Show/hide another field based on the selected value of this field
            for(let showHideField of this.showHideFields)
            {
                showHideField.addEventListener('change', event =>
                {
                    let fieldToToggle = showHideField.getAttribute('data-show-hide-field-id'),
                        fieldValueToActivateExtraField = showHideField.getAttribute('data-show-hide-field-selected-value');

                    if(document.getElementById(fieldToToggle))
                    {
                        if(showHideField.value.toLowerCase() === 'yes' || showHideField.value.toLowerCase() === 'other' || showHideField.value.toLowerCase() === 'all-subscriptions' || (showHideField.options[showHideField.selectedIndex].hasAttribute('data-show-field') && showHideField.options[showHideField.selectedIndex].getAttribute('data-show-field') === '1') || (fieldValueToActivateExtraField && showHideField.value === fieldValueToActivateExtraField))
                        {
                            document.getElementById(fieldToToggle).classList.remove('hidden');

                            if(document.getElementById(fieldToToggle).querySelector('input'))
                            {
                                document.getElementById(fieldToToggle).querySelector('input').disabled = false;
                            }
                            if(document.getElementById(fieldToToggle).querySelector('select'))
                            {
                                document.getElementById(fieldToToggle).querySelector('select').disabled = false;
                            }
                        }
                        else
                        {
                            document.getElementById(fieldToToggle).classList.add('hidden');

                            if(document.getElementById(fieldToToggle).querySelector('input'))
                            {
                                document.getElementById(fieldToToggle).querySelector('input').disabled = true;
                            }
                            if(document.getElementById(fieldToToggle).querySelector('select'))
                            {
                                document.getElementById(fieldToToggle).querySelector('select').disabled = true;
                            }
                        }
                    }
                });
            }


            //Loop through sectioned forms
            if(this.sectionedForms)
            {
                for(let sectionedForm of this.sectionedForms)
                {
                    let sectionedFormButtons = sectionedForm.querySelectorAll('[data-form-section-to]'),
                        sectionedFormSubmitButton = sectionedForm.querySelector('[data-submit-form=\'true\']');
                        
                    //Loop through section buttons
                    for(let sectionedFormButton of sectionedFormButtons)
                    {
                        sectionedFormButton.addEventListener('click', event =>
                        {
                            //Get the next form section number (whether the user is going back or forwards)
                            let nextSectionNumber = sectionedFormButton.getAttribute('data-form-section-to'),
                                //Get the current form section number
                                currentSectionNumber = sectionedForm.querySelector('.form__section--active').getAttribute('data-form-section');

                            //If we're going forward a section, we want to validate the fields
                            if((parseInt(nextSectionNumber) > parseInt(currentSectionNumber)))
                            {
                                //If the required fields in this section are validated
                                if(this.validateFormsFields(sectionedFormButton.closest('.form__section')) === 'success')
                                {
                                    this.changeActiveFormSection(sectionedForm, nextSectionNumber, currentSectionNumber);
                                }
                                else
                                {
                                    sectionedForm.querySelector('.form-steps__step--active').classList.remove('form-steps__step--valid');
                                }
                            }
                            //If we're going back a section we don't need to validate the fields
                            else
                            {
                                this.changeActiveFormSection(sectionedForm, nextSectionNumber, currentSectionNumber);
                            }
                        });
                    }


                    //On click of a sectioned form submit button, validate the last sections fields then submit the form
                    if(sectionedFormSubmitButton)
                    {
                        sectionedFormSubmitButton.addEventListener('click', event =>
                        {
                            event.preventDefault();

                            //If the last sections fields are valid, submit the form
                            if(this.validateFormsFields(sectionedFormSubmitButton.closest('.form__section')) === 'success')
                            {
                                sectionedFormSubmitButton.closest('form').submit();
                            }
                        });
                    }
                }
            }


            //Loop through clonable field sections
            if(this.clonableFieldSections)
            {
                for(let clonableFieldSection of this.clonableFieldSections)
                {
                    let cloneButton = clonableFieldSection.querySelector('.form__clone-section__button--add'),
                        addressCopyCheckbox = clonableFieldSection.querySelector('.player-address-copy-from-parent');
                        

                    //Copy address fields from parent on click of clone button (for parent portal registration)
                    if(addressCopyCheckbox)
                    {
                        addressCopyCheckbox.addEventListener('click', event =>
                        {
                            if(addressCopyCheckbox.checked === true)
                            {
                                if(clonableFieldSection.querySelector('.player-address-line-1-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-line-1-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_line_1');
                                }
                                if(clonableFieldSection.querySelector('.player-address-line-2-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-line-2-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_line_2');
                                }
                                if(clonableFieldSection.querySelector('.player-address-town-city-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-town-city-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_town_city');
                                }
                                if(clonableFieldSection.querySelector('.player-address-borough-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-borough-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_borough');
                                }
                                if(clonableFieldSection.querySelector('.player-address-borough-other-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-borough-other-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_borough_other');
                                    
                                    //Show address borough 'other' field if value of borough field is set to other
                                    if(clonableFieldSection.querySelector('.player-address-borough-other-field-container') && clonableFieldSection.closest('form').querySelector('[name=address_borough]').value === 'Other')
                                    {
                                        clonableFieldSection.querySelector('.player-address-borough-other-field-container').classList.remove('hidden');
                                    }
                                }
                                if(clonableFieldSection.querySelector('.player-address-county-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-county-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_county');
                                }
                                if(clonableFieldSection.querySelector('.player-address-country-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-country-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_country');
                                }
                                if(clonableFieldSection.querySelector('.player-address-postcode-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-postcode-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_postcode');
                                }
                            }
                            else
                            {
                                if(clonableFieldSection.querySelector('.player-address-line-1-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-line-1-field').value = '';
                                }
                                if(clonableFieldSection.querySelector('.player-address-line-2-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-line-2-field').value = '';
                                }
                                if(clonableFieldSection.querySelector('.player-address-town-city-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-town-city-field').value = '';
                                }
                                if(clonableFieldSection.querySelector('.player-address-borough-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-borough-field').value = '';
                                }
                                if(clonableFieldSection.querySelector('.player-address-county-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-county-field').value = '';
                                }
                                if(clonableFieldSection.querySelector('.player-address-country-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-country-field').value = '';
                                }
                                if(clonableFieldSection.querySelector('.player-address-postcode-field'))
                                {
                                    clonableFieldSection.querySelector('.player-address-postcode-field').value = '';
                                }
                            }
                        });
                    }
                        

                    //Clone fields on click of clone button
                    cloneButton.addEventListener('click', event =>
                    {
                        let clonableFieldSectionItems = clonableFieldSection.querySelectorAll('.form__clone-section__fields'),
                            clonableFieldSectionFirst = clonableFieldSectionItems[0],
                            clonableFieldSectionLast = clonableFieldSectionItems[clonableFieldSectionItems.length - 1];

                        if(clonableFieldSectionItems)
                        {
                            //Section of fields to clone
                            let clonedFieldsSection = clonableFieldSectionFirst.cloneNode(true),
                                clonedFieldsSectionDeleteButton = clonedFieldsSection.querySelector('.form__clone-section__button--delete'),
                                clonedFieldsSectionAddressCopyCheckbox = clonedFieldsSection.querySelector('.player-address-copy-from-parent'),
                                clonedFieldShowHideFields = clonedFieldsSection.querySelectorAll('[data-show-hide-field-id]');

                            //Fields within the section
                            let clonedFieldsSectionFieldRows = clonedFieldsSection.querySelectorAll('.form-row');

                            //Loop through the field rows in the section
                            for(let clonedFieldsSectionFieldRow of clonedFieldsSectionFieldRows)
                            {
                                //Get fields for this row (should only be one)
                                let fields = clonedFieldsSectionFieldRow.querySelectorAll('select, input, textarea');

                                for(let field of fields)
                                {   
                                    //Set the field value to blank
                                    field.value = '';

                                    //Append one to the field name
                                    field.name = field.name.replace('[0]', '[' + ( clonableFieldSectionItems.length) + ']');

                                    field.classList.remove('form__field--passed-validation');
                                    
                                    //Append one to the field id
                                    field.id = field.id.replace('[0]', '[' + ( clonableFieldSectionItems.length) + ']');
                                    
                                    //Append one to the 'data-show-hide-field-id' attr if that exists (e.g. for disability fields)
                                    if(field.hasAttribute('data-show-hide-field-id'))
                                    {
                                        field.setAttribute('data-show-hide-field-id', field.getAttribute('data-show-hide-field-id').replace('[0]', '[' + ( clonableFieldSectionItems.length) + ']'));
                                    }

                                    //Append one to the 'data-country-field-id' attr if that exists (e.g. for postcode fields)
                                    if(field.hasAttribute('data-country-field-id'))
                                    {
                                        field.setAttribute('data-country-field-id', field.getAttribute('data-country-field-id').replace('[0]', '[' + ( clonableFieldSectionItems.length) + ']'));
                                    }
            
                                    //Get typeaheads working
                                    if(field.classList.contains('typeahead-field'))
                                    {
                                        let dataUrl = field.getAttribute('data-url');
                                        
                                        if(dataUrl)
                                        {
                                            typeahead({
                                                input: field,
                                                source: {
                                                    remote: {
                                                        url: dataUrl,
                                                        wildcard: '%QUERY'
                                                    },
                                                    identifier: 'name'
                                                },
                                                display: (selected_item, event) =>
                                                {
                                                    if(document.getElementById(field.getAttribute('id') + '-salesforce-id[' + clonableFieldSectionItems.length + ']'))
                                                    {
                                                        document.getElementById(field.getAttribute('id') + '-salesforce-id[' + clonableFieldSectionItems.length + ']').value = selected_item.id;
                                                    }
                            
                                                    return selected_item.name;
                                                },
                                                preventSubmit: true
                                            });
                                        }

                                        //On blur, if the user hasn't selected a typeahead option, remove the custom value they've entered into the input field
                                        field.addEventListener('blur', event =>
                                        {
                                            if(field.closest('.typeahead-standalone').querySelector('.tt-list') && !field.closest('.typeahead-standalone').querySelector('.tt-list').classList.contains('tt-hide'))
                                            {
                                                field.value = '';   
                                            }
                                        });
                                    }

                                    //Get typeaheads working
                                    // if(field.classList.contains('date-of-birth-field'))
                                    // {
                                    //     //Remove any current age text
                                    //     if(field.nextElementSibling && field.nextElementSibling.classList.contains('form__field__notice--active'))
                                    //     {
                                    //         field.nextElementSibling.innerHTML = '';
                                    //     }

                                    //     field.addEventListener('change', event =>
                                    //     {
                                    //         if(field.nextSibling === null)
                                    //         {
                                    //             var ageTextElement = document.createElement("div");
                                    //         }
                                    //         else
                                    //         {
                                    //             var ageTextElement = field.nextSibling;
                                    //         }
                                            
                                    //         ageTextElement.classList.add('form__field__notice', 'form__field__notice--plain', 'form__field__notice--active');
                                            
                                    //         let todaysDate = new Date(),
                                    //             selectedDate = new Date(event.target.value);
                                                
                                    //         todaysDate.toISOString().substring(0,10);
                            
                                    //         if(this.calculateDateDifference(todaysDate, selectedDate))
                                    //         {
                                    //             ageTextElement.classList.remove('hidden');
                                    //             ageTextElement.innerHTML = 'Your child is ' + this.calculateDateDifference(todaysDate, selectedDate) + ' old';
                                    //         }
                                    //         else
                                    //         {
                                    //             ageTextElement.classList.add('hidden');
                                    //         }
                            
                                    //         field.after(ageTextElement);
                                    //     });
                                    // }
                                }

                                //Append one to the field label if a label exists and it has a 'for' attribute
                                if(clonedFieldsSectionFieldRow.querySelector('label') && clonedFieldsSectionFieldRow.querySelector('label').getAttribute('for'))
                                {
                                    clonedFieldsSectionFieldRow.querySelector('label').setAttribute('for', clonedFieldsSectionFieldRow.querySelector('label').getAttribute('for').replace('[0]', '[' + ( clonableFieldSection.length) + ']'));
                                }

                                //Append one to the field row id
                                if(clonedFieldsSectionFieldRow.id)
                                {
                                    clonedFieldsSectionFieldRow.id = clonedFieldsSectionFieldRow.id.replace('[0]', '[' + ( clonableFieldSectionItems.length) + ']');
                                }
                            }


                            //Show\hide fields based on value set of another field (e.g. for disability field)
                            for(let showHideField of clonedFieldShowHideFields)
                            {
                                showHideField.addEventListener('change', event =>
                                {
                                    let fieldToToggle = showHideField.getAttribute('data-show-hide-field-id');
                    
                                    if(document.getElementById(fieldToToggle))
                                    {
                                        if(showHideField.value === 'yes' || showHideField.value === 'Other')
                                        {
                                            document.getElementById(fieldToToggle).classList.remove('hidden');
                                        }
                                        else
                                        {
                                            document.getElementById(fieldToToggle).classList.add('hidden');
                                        }
                                    }
                                });
                            }

                            
                            for(let cloneButton of clonableFieldSection.querySelectorAll('.form__clone-section__delete__button'))
                            {
                                cloneButton.classList.add('form__clone-section__delete__button--deactive');
                            }


                            if(clonedFieldsSectionDeleteButton)
                            {
                                //Show the 'delete cloned section' button
                                if(clonedFieldsSectionDeleteButton.closest('.form__clone-section__delete__button'))
                                {
                                    clonedFieldsSectionDeleteButton.closest('.form__clone-section__delete__button').classList.remove('hidden', 'form__clone-section__delete__button--deactive');
                                }

                                //On click of the delete cloned fields button
                                clonedFieldsSectionDeleteButton.addEventListener('click', event =>
                                {
                                    //If ths button does not contain the 'deactive' class (it is clickable)
                                    if(!clonedFieldsSectionDeleteButton.closest('.form__clone-section__delete__button').classList.contains('form__clone-section__delete__button--deactive'))
                                    {
                                        //Allow the 'delete' button in the previous cloned fields section to be clicked
                                        clonedFieldsSection.previousSibling.querySelector('.form__clone-section__delete__button').classList.remove('form__clone-section__delete__button--deactive');

                                        //Delete this cloned fields section
                                        clonedFieldsSection.remove();
                                        
                                    }
                                });
                            }


                            //Uncheck the 'address' copy checkbox and set the click event, if it exists
                            if(clonedFieldsSectionAddressCopyCheckbox)
                            {
                                clonedFieldsSectionAddressCopyCheckbox.checked = false;

                                clonedFieldsSectionAddressCopyCheckbox.addEventListener('click', event =>
                                {
                                    if(clonedFieldsSectionAddressCopyCheckbox.checked === true)
                                    {
                                        clonedFieldsSection.querySelector('.player-address-line-1-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_line_1');
                                        clonedFieldsSection.querySelector('.player-address-line-2-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_line_2');
                                        clonedFieldsSection.querySelector('.player-address-town-city-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_town_city');
                                        clonedFieldsSection.querySelector('.player-address-county-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_county');
                                        clonedFieldsSection.querySelector('.player-address-country-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_country');
                                        clonedFieldsSection.querySelector('.player-address-postcode-field').value = this.copyFieldValue(clonableFieldSection.closest('form'), 'address_postcode');
                                    }
                                    else
                                    {
                                        clonedFieldsSection.querySelector('.player-address-line-1-field').value = '';
                                        clonedFieldsSection.querySelector('.player-address-line-2-field').value = '';
                                        clonedFieldsSection.querySelector('.player-address-town-city-field').value = '';
                                        clonedFieldsSection.querySelector('.player-address-county-field').value = '';
                                        clonedFieldsSection.querySelector('.player-address-country-field').value = '';
                                        clonedFieldsSection.querySelector('.player-address-postcode-field').value = '';
                                    }
                                });
                            }

                            
                            //Insert the cloned fields
                            clonableFieldSectionLast.after(clonedFieldsSection);
                        }
                    });
                }
            }

            
            //Submit footer newsletter signup form via Ajax
            if(this.mailingListsignupForm)
            {
                this.mailingListsignupForm.addEventListener('keyup', event =>
                {
                    if(event.key === "Enter")
                    {
                        event.preventDefault();

                        if(this.validateFormsFields(this.mailingListsignupForm) === 'success')
                        {
                            this.submitForm(this.mailingListsignupForm, true);                    
                        }
                    }
                });
            }

            
            //Visual validation for required form fields
            if(this.formFields)
            {
                for(let formField of this.formFields)
                {
                    //Get the data-field-type attribute if it exists, used to set relevant validation methods based on the field type (postcode, phone number etc)
                    let fieldValidationType = formField.getAttribute('data-field-type');                            

                    //If a required field
                    if(formField.classList.contains(this.fieldRequiredClass))
                    {
                        //Add failed validation class on focus of field
                        formField.addEventListener('focus', event =>
                        {
                            if(!event.target.value)
                            {
                                formField.classList.add(this.fieldFailedValidationClass);
                                
                                // if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling && formField.closest('.form__field').nextElementSibling.classList.contains('form__field__notice'))
                                // {
                                //     formField.closest('.form__field').nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                                // }
                            }
                        });


                        //Add failed validation class on focus of field
                        formField.addEventListener('click', event =>
                        {
                            //Styled radio
                            if(event.target.getAttribute('type') === 'radio')
                            {
                                if(event.target.checked)
                                {
                                    if(formField.closest('.form__field__options') && formField.closest('.form__field__options').nextElementSibling && formField.closest('.form__field__options').nextElementSibling.classList.contains('form__field__notice'))
                                    {
                                        formField.closest('.form__field__options').nextElementSibling.classList.add('form__field__notice--passed-validation');
                                    }
                                }

                            }


                            //Checkbox
                            if(event.target.getAttribute('type') === 'checkbox')
                            {
                                if(event.target.checked)
                                {
                                    if(formField.closest('.checkbox'))
                                    {
                                        formField.closest('.checkbox').classList.remove(this.checkboxFieldLabelFailedValidationClass);
                                        formField.closest('.checkbox').classList.add(this.checkboxFieldLabelPassedValidationClass);
                                    }
                                }
                                else
                                {
                                    if(formField.closest('.checkbox'))
                                    {
                                        formField.closest('.checkbox').classList.add(this.checkboxFieldLabelFailedValidationClass);
                                        formField.closest('.checkbox').classList.remove(this.checkboxFieldLabelPassedValidationClass);
                                    }
                                }
                            }
                        });


                        //Add/remove validation class depending on select field having a value
                        formField.addEventListener('change', event =>
                        {
                            if(event.target.nodeName === 'SELECT' || (event.target.nodeName === 'INPUT' && event.target.getAttribute('type') === 'date'))
                            {
                                if(!event.target.value)
                                {
                                    formField.classList.add(this.fieldFailedValidationClass);
                                    formField.classList.remove(this.fieldPassedValidationClass);
                                }
                                else
                                {
                                    formField.classList.remove(this.fieldFailedValidationClass);
                                    formField.classList.add(this.fieldPassedValidationClass);
                                }
                            }
                        });


                        //Add/remove validation class depending on field value length
                        formField.addEventListener('keyup', event =>
                        {
                            let form = formField.closest('.form');

                            if(event.target.getAttribute('type') === 'text' || event.target.getAttribute('type') === 'password' || event.target.getAttribute('type') === 'number' || event.target.getAttribute('type') === 'textarea' || event.target.getAttribute('type') === 'email')
                            {
                                //If an email field, check value is a valid email address
                                if(event.target.getAttribute('type') === 'email')
                                {
                                    if(this.passedEmailAddressValidation(event.target.value))
                                    {
                                        // if(formField.getAttribute('data-check-portal-users') === 'true')
                                        // {
                                        //     formField.classList.add(this.fieldLoadingClass);

                                        //     setTimeout(() =>
                                        //     {             
                                        //         if(this.userEmailExists(event.target.value))
                                        //         {
                                        //             formField.classList.add(this.fieldFailedValidationClass);
                                        //             formField.classList.remove(this.fieldPassedValidationClass);

                                        //             formField.classList.remove(this.fieldLoadingClass);

                                        //             //Show 'email in use' message
                                        //             if(formField.nextElementSibling.classList.contains('form__field__notice--email-in-use'))
                                        //             {
                                        //                 formField.nextElementSibling.classList.add('form__field__notice--active');
                                        //             }
                                        //         }
                                        //         else
                                        //         {
                                        //             formField.classList.remove(this.fieldFailedValidationClass);
                                        //             formField.classList.add(this.fieldPassedValidationClass);

                                        //             formField.classList.remove(this.fieldLoadingClass);

                                        //             //Hide 'email in use' message
                                        //             if(formField.nextElementSibling.classList.contains('form__field__notice--email-in-use'))
                                        //             {
                                        //                 formField.nextElementSibling.classList.remove('form__field__notice--active');
                                        //             }
                                        //         }
                                        //     }, 500);
                                        // }
                                        // else
                                        // {
                                            formField.classList.remove(this.fieldFailedValidationClass);
                                            formField.classList.add(this.fieldPassedValidationClass);
                                        // }
                                    }
                                    else
                                    {
                                        formField.classList.add(this.fieldFailedValidationClass);
                                        formField.classList.remove(this.fieldPassedValidationClass);
                                    }
                                }
                                else
                                {
                                    if(fieldValidationType)
                                    {
                                        switch(fieldValidationType)
                                        {
                                            //DUPLICATE IN validateFormsFields METHOD
                                            case 'password' : case 'password-confirm' :
                                            {
                                                if(this.passedPasswordValidation(event.target.value, fieldValidationType === 'password-confirm' ? true : false))
                                                {
                                                    formField.classList.remove(this.fieldFailedValidationClass);
                                                    formField.classList.add(this.fieldPassedValidationClass);

                                                    if(formField.closest('.form__item'))
                                                    {
                                                        formField.closest('.form__item').classList.add(this.fieldParentPassedValidationClass);
                                                    }

                                                    if(formField.closest('.password-input') && formField.closest('.password-input').nextElementSibling && formField.closest('.password-input').nextElementSibling.classList.contains('description'))
                                                    {
                                                        formField.closest('.password-input').nextElementSibling.classList.add(this.fieldNoticePassedValidationClass);
                                                    }
                                                    
                                                    //Show field notice
                                                    if(formField.closest('.password-input').nextElementSibling && formField.closest('.password-input').nextElementSibling.classList.contains('description'))
                                                    {
                                                        formField.closest('.password-input').nextElementSibling.classList.remove(this.fieldNoticeActiveClass);
                                                        formField.closest('.password-input').nextElementSibling.classList.add(this.fieldNoticePassedValidationClass);
                                                        formField.closest('.password-input').nextElementSibling.setAttribute('aria-hidden', true);
                                                    }
                                                }
                                                else
                                                {
                                                    formField.classList.add(this.fieldFailedValidationClass);
                                                    formField.classList.remove(this.fieldPassedValidationClass);

                                                    if(formField.closest('.form__item'))
                                                    {
                                                        formField.closest('.form__item').classList.remove(this.fieldParentPassedValidationClass);
                                                    }
        
                                                    if(formField.closest('.password-input') && formField.closest('.password-input').nextElementSibling && formField.closest('.password-input').nextElementSibling.classList.contains('description'))
                                                    {
                                                        formField.closest('.password-input').nextElementSibling.classList.remove(this.fieldNoticePassedValidationClass);
                                                    }
                                                    
                                                    //Show field notice
                                                    if(formField.closest('.password-input').nextElementSibling && formField.closest('.password-input').nextElementSibling.classList.contains('description'))
                                                    {
                                                        formField.closest('.password-input').nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                                                        formField.closest('.password-input').nextElementSibling.classList.remove(this.fieldNoticePassedValidationClass);
                                                        formField.closest('.password-input').nextElementSibling.setAttribute('aria-hidden', false);
                                                    }
                                                }

                                                break;   
                                            }

                                            //DUPLICATE IN validateFormsFields METHOD
                                            case 'postcode' :
                                            {
                                                event.target.value = event.target.value.toUpperCase();

                                                let countryFieldId = event.target.getAttribute('data-country-field-id') ? event.target.getAttribute('data-country-field-id') : '';

                                                if(this.passedPostcodeValidation(event.target.value, countryFieldId))
                                                {
                                                    formField.classList.remove(this.fieldFailedValidationClass);
                                                    formField.classList.add(this.fieldPassedValidationClass);

                                                    if(formField.closest('.form__item'))
                                                    {
                                                        formField.closest('.form__item').classList.add(this.fieldParentPassedValidationClass);
                                                    }

                                                    if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling && formField.closest('.form__field').nextElementSibling.classList.contains('form__field__notice'))
                                                    {
                                                        formField.closest('.form__field').nextElementSibling.classList.add(this.fieldNoticePassedValidationClass);
                                                    }
                                                    
                                                    //Hide field notice
                                                    if(formField.nextElementSibling && formField.nextElementSibling.classList.contains('description'))
                                                    {
                                                        formField.nextElementSibling.classList.remove(this.fieldNoticeActiveClass);
                                                        formField.nextElementSibling.classList.add(this.fieldNoticePassedValidationClass);
                                                        formField.nextElementSibling.setAttribute('aria-hidden', true);
                                                    }
                                                }
                                                else
                                                {                                                                                     
                                                    formField.classList.add(this.fieldFailedValidationClass);
                                                    formField.classList.remove(this.fieldPassedValidationClass);

                                                    if(formField.closest('.form__item'))
                                                    {
                                                        formField.closest('.form__item').classList.remove(this.fieldParentPassedValidationClass);
                                                    }
        
                                                    if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling && formField.closest('.form__field').nextElementSibling.classList.contains('form__field__notice'))
                                                    {
                                                        formField.closest('.form__field').nextElementSibling.classList.remove(this.fieldNoticePassedValidationClass);
                                                    }
                                                    
                                                    //Show field notice
                                                    if(formField.nextElementSibling && formField.nextElementSibling.classList.contains('description'))
                                                    {
                                                        formField.nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                                                        formField.nextElementSibling.classList.remove(this.fieldNoticePassedValidationClass);
                                                        formField.nextElementSibling.setAttribute('aria-hidden', false);
                                                    }
                                                }

                                                break;   
                                            }

                                            //DUPLICATE IN validateFormsFields METHOD
                                            case 'currency' :
                                            {
                                                if(this.passedCurrencyValidation(event.target.value))
                                                {
                                                    formField.classList.remove(this.fieldFailedValidationClass);
                                                    formField.classList.add(this.fieldPassedValidationClass);
                                                }
                                                else
                                                {
                                                    formField.classList.add(this.fieldFailedValidationClass);
                                                    formField.classList.remove(this.fieldPassedValidationClass);
                                                }

                                                break;   
                                            }

                                            //DUPLICATE IN validateFormsFields METHOD
                                            case 'phone' :
                                            {
                                                if(this.passedPhoneNumberValidation(event.target.value))
                                                {
                                                    formField.classList.remove(this.fieldFailedValidationClass);
                                                    formField.classList.add(this.fieldPassedValidationClass);
                                                }
                                                else
                                                {
                                                    formField.classList.add(this.fieldFailedValidationClass);
                                                    formField.classList.remove(this.fieldPassedValidationClass);
                                                }

                                                break;   
                                            }
                                        }
                                    }
                                    else
                                    {
                                        if(!event.target.value.length)
                                        {
                                            formField.classList.add(this.fieldFailedValidationClass);
                                            formField.classList.remove(this.fieldPassedValidationClass);
                                        }
                                        else
                                        {
                                            formField.classList.remove(this.fieldFailedValidationClass);
                                            formField.classList.add(this.fieldPassedValidationClass);
                                        }
                                    }
                                }
                            }
                        });
                    }
                }
            }
        },
        
        /*
        Works out the years and momths between two dates

        @param {Date} startingDate - the starting date to compare
        @param {Date} endingDate - the ending date to compare
        */
        calculateDateDifference(startingDate, endingDate)
        {
            let startDate = new Date(new Date(startingDate).toISOString().substr(0, 10));

            if(!endingDate)
            {
                endingDate = new Date().toISOString().substr(0, 10);
            }
            
            let endDate = new Date(endingDate);

            if(startDate > endDate)
            {
                const swap = startDate;
                startDate = endDate;
                endDate = swap;
            }
            
            const startYear = startDate.getFullYear();
          
            let yearDiff = endDate.getFullYear() - startYear;
            
            let monthDiff = endDate.getMonth() - startDate.getMonth();
            
            if(monthDiff < 0)
            {
                yearDiff--;
                monthDiff += 12;
            }

            let dayDiff = endDate.getDate() - startDate.getDate();
            
            // if(dayDiff < 0)
            // {
            //     if(monthDiff > 0)
            //     {
            //         monthDiff--;
            //     }
            //     else
            //     {
            //         yearDiff--;
            //         monthDiff = 11;
            //     }

            //     dayDiff += daysInMonth[startDate.getMonth()];
            // }
          
            if(yearDiff > 0 || (yearDiff === 0 && monthDiff > 0))
            {
                return (yearDiff > 0 ? yearDiff + ' year' + (yearDiff > 1 ? 's' : '') : '') + (monthDiff > 0 ? (yearDiff > 0 ? ' and ' : '') + monthDiff + ' month' + (monthDiff > 1 ? 's' : '') : '')/* + dayDiff + 'D'*/;
            }
        },

        /*
        Changes the active form section for forms split into sections

        @param {Object} form - the form that contains the field
        @param {Object} fieldName - the name of the field to copy the value from
        */
        copyFieldValue: function(form, fieldName)
        {
            return form.querySelector('[name=' + fieldName + ']') && form.querySelector('[name=' + fieldName + ']').value ? form.querySelector('[name=' + fieldName + ']').value : '';
        },

        /*
        Changes the active form section for forms split into sections

        @param {Object} sectionedForm - the sectioned form
        @param {Object} nextSectionNumber - the next section we're going to
        @param {Object} currentSectionNumber - the current section we're on
        */
        changeActiveFormSection: function(sectionedForm, nextSectionNumber, currentSectionNumber)
        {
            //Hide current active section
            sectionedForm.querySelector('.form__section--active').classList.remove('form__section--active');
        
            //Show section specified via attr data-form-section-to
            sectionedForm.querySelector('.form__section[data-form-section=\'' + nextSectionNumber +'\']').classList.add('form__section--active');

            //Highlight active form step tab
            if(sectionedForm.querySelector('.form-steps'))
            {
                //Deactive the active form step tab
                if(sectionedForm.querySelector('.form-steps__step--active'))
                {
                    //If we're going forward a section, add the 'valid' class to the step tab
                    if(currentSectionNumber < nextSectionNumber && sectionedForm.querySelector('.form-steps__step--active'))
                    {
                        sectionedForm.querySelector('.form-steps__step--active').classList.add('form-steps__step--valid');
                    }

                    //Deactivate the current active step tab
                    if(sectionedForm.querySelector('.form-steps__step--active'))
                    {
                        sectionedForm.querySelector('.form-steps__step--active').classList.remove('form-steps__step--active');
                    }
                }

                //Activate the current form step
                if(sectionedForm.querySelector('.form-steps__step[data-form-section-step-no=\'' + nextSectionNumber +'\']'))
                {
                    sectionedForm.querySelector('.form-steps__step[data-form-section-step-no=\'' + nextSectionNumber +'\']').classList.add('form-steps__step--active');
                }
            }
        },

        /*
        Validates the fields within a form

        @param {Object} field - the form element
        */
        validateFormsFields: function(form)
        {
            let sendForm = '',
                formFields = form.querySelectorAll('select, input, textarea');

            //Loop through form fields
            for(let formField of formFields)
            {
                //Get the data-field-type attribute if it exists, used to set relevant validation methods based on the field type (postcode, phone number etc)
                let fieldValidationType = formField.getAttribute('data-field-type');                            

                //If field is required, validate it
                if(formField.classList.contains(this.fieldRequiredClass))
                {
                    //Validate different field types
                    switch(formField.type)
                    {
                        default :
                        {
                            if(formField.value === "" && !formField.disabled)
                            {
                                formField.classList.add(this.fieldFailedValidationClass);
                                sendForm += 'error';

                                //Add valid email notice after field
                                if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                {
                                    formField.closest('.form__field').nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                                }
                            }
                            else
                            {
                                if(!fieldValidationType)
                                {
                                    formField.classList.remove(this.fieldFailedValidationClass);
                                    sendForm += '';

                                    //Remove valid email notice after field
                                    if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                    {
                                        formField.closest('.form__field').nextElementSibling.classList.remove(this.fieldNoticeActiveClass);
                                    }
                                }
                                else
                                {
                                    switch(fieldValidationType)
                                    {
                                        case 'password' : case 'password-confirm' :
                                        {
                                            if(this.passedPasswordValidation(formField.value, fieldValidationType === 'password-confirm' ? true : false))
                                            {
                                                sendForm += '';

                                                formField.classList.add('form__field--passed-validation');
                                                formField.classList.remove('form__field--failed-validation');

                                                //Remove valid email notice after field
                                                if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                                {
                                                    formField.closest('.form__field').nextElementSibling.classList.remove(this.fieldNoticeActiveClass);
                                                }
                                            }
                                            else
                                            {
                                                sendForm += 'error';

                                                formField.classList.remove('form__field--passed-validation');
                                                formField.classList.add('form__field--failed-validation');

                                                //Add valid email notice after field
                                                if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                                {
                                                    formField.closest('.form__field').nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                                                }
                                            }

                                            break;   
                                        }

                                        case 'postcode' :
                                        {
                                            let countryFieldId = formField.getAttribute('data-country-field-id') ? formField.getAttribute('data-country-field-id') : '';

                                            if(this.passedPostcodeValidation(formField.value, countryFieldId))
                                            {
                                                sendForm += '';

                                                formField.classList.add('form__field--passed-validation');
                                                formField.classList.remove('form__field--failed-validation');

                                                //Remove valid email notice after field
                                                if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                                {
                                                    formField.closest('.form__field').nextElementSibling.classList.remove(this.fieldNoticeActiveClass);
                                                }
                                            }
                                            else
                                            {
                                                sendForm += 'error';

                                                formField.classList.remove('form__field--passed-validation');
                                                formField.classList.add('form__field--failed-validation');

                                                //Add valid email notice after field
                                                if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                                {
                                                    formField.closest('.form__field').nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                                                }
                                            }

                                            break;   
                                        }

                                        case 'currency' :
                                        {
                                            if(this.passedCurrencyValidation(formField.value))
                                            {
                                                sendForm += '';

                                                formField.classList.add('form__field--passed-validation');
                                                formField.classList.remove('form__field--failed-validation');

                                                //Remove valid email notice after field
                                                if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                                {
                                                    formField.closest('.form__field').nextElementSibling.classList.remove(this.fieldNoticeActiveClass);
                                                }
                                            }
                                            else
                                            {
                                                sendForm += 'error';

                                                formField.classList.remove('form__field--passed-validation');
                                                formField.classList.add('form__field--failed-validation');

                                                //Add valid email notice after field
                                                if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                                {
                                                    formField.closest('.form__field').nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                                                }
                                            }

                                            break;   
                                        }

                                        case 'phone' :
                                        {
                                            if(this.passedPhoneNumberValidation(formField.value))
                                            {
                                                sendForm += '';

                                                formField.classList.add('form__field--passed-validation');
                                                formField.classList.remove('form__field--failed-validation');

                                                //Remove valid email notice after field
                                                if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                                {
                                                    formField.closest('.form__field').nextElementSibling.classList.remove(this.fieldNoticeActiveClass);
                                                }
                                            }
                                            else
                                            {
                                                sendForm += 'error';

                                                formField.classList.remove('form__field--passed-validation');
                                                formField.classList.add('form__field--failed-validation');

                                                //Add valid email notice after field
                                                if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                                                {
                                                    formField.closest('.form__field').nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                                                }
                                            }

                                            break;   
                                        }
                                    }
                                }
                            }

                            break;
                        }
                    }
                }

                //If email input, validate value
                if(formField.type === 'email')
                {
                    if(this.passedEmailAddressValidation(formField.value))
                    {
                        formField.classList.remove(this.fieldFailedValidationClass);

                        sendForm += '';

                        //Remove valid email notice after field
                        if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                        {
                            formField.closest('.form__field').nextElementSibling.classList.remove(this.fieldNoticeActiveClass);
                        }
                    }
                    else
                    {
                        formField.classList.add(this.fieldFailedValidationClass);

                        sendForm += 'error';

                        //Add valid email notice after field
                        if(formField.closest('.form__field') && formField.closest('.form__field').nextElementSibling)
                        {
                            formField.closest('.form__field').nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                        }
                    }
                }
            }


            //Checkbox and radio input field validation
            let allMultiSelectFields = form.querySelectorAll('input[type=radio], input[type=checkbox]'),
                requiredMultiSelectFieldNames = [];

            for(let formField of allMultiSelectFields)
            {
                //If field is required, validate it
                if(formField.classList.contains(this.fieldRequiredClass))
                {
                    if(!requiredMultiSelectFieldNames.includes(formField.name))
                    {
                        requiredMultiSelectFieldNames.push(formField.name);
                    }
                }
            }

            for(let requiredMultiSelectField of requiredMultiSelectFieldNames)
            {
                let fields = document.getElementsByName(requiredMultiSelectField);
                let selectedFields = [];
                
                for(let field of fields)
                {
                    if(field.checked)
                    {
                        selectedFields.push('selected');
                    }
                }
                fields = [];

                if(selectedFields.length > 0)
                {
                    if(form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options'))
                    {
                        if(form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options'))
                        {
                            form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options').classList.remove(this.radioFieldLabelFailedValidationClass);
                        }
                        
                        if(form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options').nextElementSibling)
                        {
                            form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options').nextElementSibling.classList.remove(this.fieldNoticeActiveClass);
                        }

                        sendForm += '';
                    }

                    //Remove failed validation class to Woocommerce checkbox fields
                    if(form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.checkbox--label'))
                    {
                        form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.checkbox--label').classList.remove(this.checkboxFieldLabelFailedValidationClass);
                    }
                }
                else
                {
                    if(form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options'))
                    {
                        if(form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options'))
                        {
                            form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options').classList.add(this.radioFieldLabelFailedValidationClass);
                        }

                        if(form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options').nextElementSibling)
                        {
                            form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.form__field__options').nextElementSibling.classList.add(this.fieldNoticeActiveClass);
                        }
                    }
                    //Add failed validation class to Woocommerce checkbox fields
                    if(form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.checkbox--label'))
                    {
                        form.querySelector('input[name="' + requiredMultiSelectField + '"]').closest('.checkbox--label').classList.add(this.checkboxFieldLabelFailedValidationClass);
                    }
                    sendForm += 'error';
                }
            }


            //If all fields have passed validation, submit the data
            if(sendForm === '')
            {
                return 'success';
            }
            else
            {
                //Scroll to the first invalid field in the form
                if(form.querySelector('.' + this.fieldFailedValidationClass))
                {
                    form.querySelector('.' + this.fieldFailedValidationClass).scrollIntoView();
                }
                else if(form.querySelector('.' + this.checkboxFieldLabelFailedValidationClass))
                {
                    form.querySelector('.' + this.checkboxFieldLabelFailedValidationClass).scrollIntoView();
                }
                else if(form.querySelector('.' + this.radioFieldLabelFailedValidationClass))
                {
                    form.querySelector('.' + this.radioFieldLabelFailedValidationClass).scrollIntoView();
                }
            }
        },

        /*
        Submits the form data

        @param {Object} form - the form element
        @param {Boolean} submitViaAjax - whether the form has been submitted via ajax or not
        */
        submitForm: function(form, submitViaAjax)
        {
            if(submitViaAjax)
            {
                let formData = new FormData(form),
                    httpRequest = new XMLHttpRequest();

                httpRequest.open('POST', form.getAttribute('action'));
                httpRequest.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
                httpRequest.setRequestHeader('Accept', 'multipart/form-data');

                httpRequest.onreadystatechange = () =>
                {
                    if(httpRequest.readyState === XMLHttpRequest.DONE && httpRequest.status === 200)
                    {
                        if(httpRequest.responseText === 'success')
                        {
                            if(form.querySelector('.form__fields'))
                            {
                                form.querySelector('.form__fields').style.display = 'none';
                            }

                            //Remove modal 'book' button when form is submitted
                            if(form.querySelector('.modal__box__cta__container'))
                            {
                                form.querySelector('.modal__box__cta__container').style.display = 'none';
                            }

                            if(form.querySelector('.'  + this.successAlertClass))
                            {
                                form.querySelector('.'  + this.successAlertClass).style.display = 'block';
                            }

                            if(form.querySelector('.'  + this.failAlertClass))
                            {
                                form.querySelector('.' + this.failAlertClass).style.display = 'none';
                            }

                            if(form.querySelector('.'  + this.spamAlertClass))
                            {
                                form.querySelector('.' + this.spamAlertClass).style.display = 'none';
                            }
                        }
                        else if(httpRequest.responseText === 'post-limit-exceeded')
                        {
                            if(form.querySelector('.'  + this.successAlertClass))
                            {
                                form.querySelector('.'  + this.successAlertClass).style.display = 'none';
                            }
                            if(form.querySelector('.' + this.failAlertClass))
                            {
                                form.querySelector('.' + this.failAlertClass).innerHTML = 'The files uploaded exceed the upload size limit, please try again.';
                                form.querySelector('.' + this.failAlertClass).style.display = 'block';
                            }

                            if(form.querySelector('.'  + this.spamAlertClass))
                            {
                                form.querySelector('.' + this.spamAlertClass).style.display = 'none';
                            }
                        }
                        else if(httpRequest.responseText === 'spam')
                        {
                            if(form.querySelector('.'  + this.successAlertClass))
                            {
                                form.querySelector('.'  + this.successAlertClass).style.display = 'none';
                            }
                            if(form.querySelector('.' + this.failAlertClass))
                            {
                                form.querySelector('.' + this.failAlertClass).style.display = 'none';
                            }

                            if(form.querySelector('.'  + this.spamAlertClass))
                            {
                                form.querySelector('.' + this.spamAlertClass).style.display = 'block';
                            }
                        }
                        else
                        {
                            if(form.querySelector('.'  + this.successAlertClass))
                            {
                                form.querySelector('.' + this.successAlertClass).style.display = 'none';
                            }

                            if(form.querySelector('.'  + this.failAlertClass))
                            {
                                form.querySelector('.' + this.failAlertClass).innerHTML = 'There was a problem sending your enquiry, please try again.';
                                form.querySelector('.' + this.failAlertClass).style.display = 'block';
                            }

                            if(form.querySelector('.'  + this.spamAlertClass))
                            {
                                form.querySelector('.' + this.spamAlertClass).style.display = 'none';
                            }
                        }
                    }
                    else
                    {
                        if(form.querySelector('.'  + this.successAlertClass))
                        {
                            form.querySelector('.' + this.successAlertClass).style.display = 'none';
                        }

                        if(form.querySelector('.'  + this.failAlertClass))
                        {
                            form.querySelector('.' + this.failAlertClass).innerHTML = 'There was a problem sending your enquiry, please try again.';
                            form.querySelector('.' + this.failAlertClass).style.display = 'block';
                        }

                        if(form.querySelector('.'  + this.spamAlertClass))
                        {
                            form.querySelector('.' + this.spamAlertClass).style.display = 'none';
                        }
                    }
                };
                
                httpRequest.send(formData);
            }
            else
            {
                form.submit();
            }
        },
        
        /*
        Validates an email address

        @param {String} email - the email address
        */
        passedEmailAddressValidation(email) 
        {
            if(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(email))
            {
                return true;
            }
            else
            {
                return false;
            }
        },
        
        /*
        Checks whether a parent portal user exists with the email 

        @param {String} email - the email address
        */
        userEmailExists(email) 
        {
            let user_exists = false;

            $.ajax({
                url: "/wp-json/wp/v2/check-user-email-address?email=" + email,
                async: false,
                dataType: 'json',
                success: (json)=>
                {
                    if(json.email_exists === true)
                    {
                        user_exists = true;
                    }
                    else
                    {
                        user_exists = false;
                    }
                }
            });

            return user_exists;
        },
        
        /*
        Validates a currency value

        @param {String} value - the value to test
        */
        passedCurrencyValidation(value) 
        {
            if(/£ ?(?:\d{1,3},)?(?:\d{6},)*\d{1,9}(?:\. ?\d+)*$/.test(value))
            //if(/£ ?(?:\d{1,3},)?(?:\d{3},)*\d{1,3}(?:\. ?\d+)*$/.test(value))
            {
                return true;
            }
            else
            {
                return false;
            }
        },

        /*
        Validates a password to ensure it's strong

        @param {String} password - the password to test
        @param {Boolean} is_confirm_field - whether the field is a password confirm field
        */
        passedPasswordValidation(password, is_confirm_field)
        {
            var lowerCaseLetters = /[a-z]/g;
            var upperCaseLetters = /[A-Z]/g;
            var numbers = /[0-9]/g;
            
            if(!password.match(lowerCaseLetters) || !password.match(upperCaseLetters) || !password.match(numbers) || password.length < 8)
            {
                return false;
            }
            else
            {
                if(is_confirm_field)
                {
                    var passwordFieldValue = document.getElementById('reg_password').value;

                    //If this password doesn't match the main password, it's not valid
                    if(password !== passwordFieldValue)
                    {
                        return false;
                    }
                    else
                    {
                        return true;
                    }
                }
                else
                {
                    return true;
                }
            }
        },
        
        /*
        Validates a UK postcode

        @param {String} value - the value to test
        @param {String} countryFieldId - the ID of the country field to check the value of before enforcing validation
        */
        passedPostcodeValidation(value, countryFieldId) 
        {
            const regex = new RegExp('^(GIR 0AA)|((([A-Z][0-9]{1,2})|(([A-Z][A-HJ-Y][0-9]{1,2})|(([A-Z][0-9][A-Z])|([A-Z][A-HJ-Y][0-9]?[A-Z])))) [0-9][A-Z]{2})$');
            
            if((document.getElementById(countryFieldId) && document.getElementById(countryFieldId).value !== 'United Kingdom') || regex.test(value))
            {
                return true;
            }
            else
            {
                return false;
            }
        },
        
        /*
        Validates a phone number

        @param {String} value - the value to test
        */
        passedPhoneNumberValidation(value) 
        {
            var regex = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

            if(value.replaceAll(' ', '').match(regex))
            {
                return true;
            }
            else
            {
                return false;
            }
        },

        /*
        Removes a given parameter from the url

        @param {String} key - the paramater string
        @param {Object} sourceURL - the source url
        */
        removeParamFromUrl(key, sourceURL) {
            let rtn = sourceURL.split("?")[0],
                param,
                params_arr = [],
                queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

            if(queryString !== "")
            {
                params_arr = queryString.split("&");

                for(let i = params_arr.length - 1; i >= 0; i -= 1)
                {
                    param = params_arr[i].split("=")[0];
                    if(param === key)
                    {
                        params_arr.splice(i, 1);
                    }
                }

                rtn = rtn + "?" + params_arr.join("&");
            }
            return rtn;
        },

        /*
        Submits the form on change of a field

        @param {Object} field - the form field element
        */
        submitFormOnchange: function(field)
        {
            const currentUrl = location.href,
                preField = currentUrl.indexOf('?') > -1 ? '&' : '?',
                alteredURL = this.removeParamFromUrl(field.name, currentUrl);

            location.href = alteredURL + preField + field.name + '=' + field.value;
        },
    };

    const header = {
        header: document.querySelector('.header'),
        headerActiveClassName: 'header--active',
        mainMenuItems: document.querySelectorAll('.main-menu .menu-item'),
        mainMenuItemsWithSubnav: document.querySelectorAll('.main-menu .menu-item-has-children > a'),
        mainMenuOpenIcon: document.getElementById('main-menu-toggle-button'),
        mainMenuCloseIcon: document.querySelector('.header__nav-close'),
        mainMenuMobileNavActiveClassName: 'header-mobile-nav-active',
        mainMenuMobileSubnavActiveClassName: 'header-mobile-nav-subnav-active',
        playerPortalMenuOpenIcon: document.getElementById('player-portal-menu-toggle-button'),
        playerPortalMenuMobileNavActiveClassName: 'header-mobile-player-portal-nav-active',
        coachPortalMenuOpenIcon: document.getElementById('coach-portal-menu-toggle-button'),
        coachPortalMenuMobileNavActiveClassName: 'header-mobile-coach-portal-nav-active',

        /*
        Initialization on page load
        */
        init()
        {
            this.setup();
        },

        /*
        Sets up the header methods
        */
        setup()
        {
            if(this.header)
            {
                window.onscroll = () =>
                {
                    this.addClassOnScroll();
                };

                window.onload = () =>
                {
                    this.addClassOnScroll();
                };
            }

            if(this.mainMenuOpenIcon)
            {
                this.mainMenuOpenIcon.addEventListener('click', () =>
                {
                    this.showHideMainMenu();
                });
            }

            if(this.playerPortalMenuOpenIcon)
            {
                this.playerPortalMenuOpenIcon.addEventListener('click', () =>
                {
                    this.showHidePlayerPortalMenu();
                });
            }

            if(this.coachPortalMenuOpenIcon)
            {
                this.coachPortalMenuOpenIcon.addEventListener('click', () =>
                {
                    this.showHideCoachPortalMenu();
                });
            }

            // if(this.mainMenuItems)
            // {
                // for(let menuItem of this.mainMenuItems)
                // {
                //     menuItem.addEventListener('click', event =>
                //     {
                //         event.stopPropagation();
                //
                //         this.hideMainMenu();
                //     });
                // }
            // }

            if(this.mainMenuItemsWithSubnav)
            {
                for(let menuItemWithSubnav of this.mainMenuItemsWithSubnav)
                {
                    //Add mobile back link on sub nav
                    let backLink = document.createElement("span");
                    backLink.className = 'back-link';

                    //Append the back link after the last menu item
                    menuItemWithSubnav.parentElement.querySelector('ul ul li:last-child').append(backLink);

                    //Hide subnav on click of back link
                    backLink.addEventListener('click', event =>
                    {
                        event.stopPropagation();

                        if(menuItemWithSubnav.parentElement)
                        {
                            menuItemWithSubnav.parentElement.classList.remove('menu-item--active');
                        }
                        
                        if(document.documentElement)
                        {
                            document.documentElement.classList.remove(this.mainMenuMobileSubnavActiveClassName);
                        }
                    });

                    //Show sub nav on click of parent menu item
                    menuItemWithSubnav.addEventListener('click', event =>
                    {
                        event.stopPropagation();

                        if(document.documentElement)
                        {
                            document.documentElement.classList.remove(this.mainMenuMobileSubnavActiveClassName);
                        }

                        this.showHideSubMenu(event.currentTarget.parentElement);
                    });
                }
            }
        },

        /*
        Adds/removes a class to the header on scroll
        */
        addClassOnScroll()
        {
            let postitionFromTop = window.pageYOffset | document.body.scrollTop;

            if(postitionFromTop > 2)
            {
                this.header.classList.add(this.headerActiveClassName, 'header--var-1--overlay');
            }
            else {
                this.header.classList.remove(this.headerActiveClassName, 'header--var-1--overlay');
            }
        },

        /*
        Toggles the class on the body to show the main menu
        */
        showHideMainMenu: function()
        {
            document.documentElement.classList.remove(this.mainMenuMobileSubnavActiveClassName);

            //Hide  active subnav when the menu is closed
            for(let menuItemWithSubnav of this.mainMenuItemsWithSubnav)
            {
                menuItemWithSubnav.classList.remove('menu-item--active');
            }

            //Deselect active nav item when the menu is closed
            for(let activeMenuItem of document.querySelectorAll('.menu-item--active'))
            {
                activeMenuItem.classList.remove('menu-item--active');
            }

            document.documentElement.classList.toggle(this.mainMenuMobileNavActiveClassName);
        },

        /*
        Toggles the class on the body to show the player portal menu
        */
        showHidePlayerPortalMenu: function()
        {
            for(let menuItemWithSubnav of this.mainMenuItemsWithSubnav)
            {
                menuItemWithSubnav.classList.remove('menu-item--active');
            }

            document.documentElement.classList.toggle(this.playerPortalMenuMobileNavActiveClassName);
        },

        /*
        Toggles the class on the body to show the coach portal menu
        */
        showHideCoachPortalMenu: function()
        {
            for(let menuItemWithSubnav of this.mainMenuItemsWithSubnav)
            {
                menuItemWithSubnav.classList.remove('menu-item--active');
            }

            document.documentElement.classList.toggle(this.coachPortalMenuMobileNavActiveClassName);
        },

        /*
        Shows/hides a sub menu item

        @param {Object} menuItem - The menu item
        */
        showHideSubMenu: function(menuItem)
        {
            document.documentElement.classList.add(this.mainMenuMobileSubnavActiveClassName);

            for(let menuItemWithSubnav of this.mainMenuItemsWithSubnav)
            {
                menuItemWithSubnav.parentElement.classList.remove('menu-item--active');
            }

            menuItem.classList.toggle('menu-item--active');
        },

        /*
        Reposition a sub menu if it's outside of the viewport

        @param {Object} menuItem - The menu item
        */
        repositionSubNav: function(menuItem)
        {
            let subMenuRightPosition = menuItem.querySelector('ul').offsetWidth + menuItem.querySelector('ul').getBoundingClientRect().left;

            //Detect if sub nav is off screen, if so add class to prevent that
            if(subMenuRightPosition > window.innerWidth)
            {
                menuItem.querySelector('ul').classList.add('off-screen');
            }
            else
            {
                menuItem.querySelector('ul').classList.remove('off-screen');
            }
        }
    };

    const modal =
    {
        modals: document.querySelectorAll('.modal'),
        modalBackgrounds: document.querySelectorAll('.modal .modal__bg'),
        modalTriggers: document.querySelectorAll('[data-modal-id]'),
        closeModalButtons: document.querySelectorAll('.modal__close'),
        nextModalButtons: document.querySelectorAll('.modal__next'),
        previousModalButtons: document.querySelectorAll('.modal__prev'),
        activeModalClass: 'modal--active',

        /*
        Initialization on page load
        */
        init: function()
        {
            //Get next modal
            for(let nextModalButton of this.nextModalButtons)
            {
                nextModalButton.addEventListener('click', () =>
                {
                    this.showNextModal(nextModalButton);
                });
            }


            //Get previous modal
            for(let previousModalButton of this.previousModalButtons)
            {
                previousModalButton.addEventListener('click', () =>
                {
                    this.showPreviousModal(previousModalButton);
                });
            }


            //Open modal when user clicks open button
            for(let modalTrigger of this.modalTriggers)
            {
                let modalID = modalTrigger.getAttribute('data-modal-id');

                modalTrigger.addEventListener('click', () =>
                {
                    this.showModal(modalID);
                });
            }


            //Close modal when user clicks close button
            for(let closeModalButton of this.closeModalButtons)
            {
                closeModalButton.addEventListener('click', () =>
                {
                    this.hideModal();
                });
            }


            //Loop through all modals
            for(let modal of this.modals)
            {
                //If a modal is set to auto display and it hasn't been previously closed, show it after 10 seconds
                if(modal.getAttribute('data-modal-auto-display'))
                {
                    if(!localStorage.getItem(modal.getAttribute('id') + '-closed', true))
                    {
                        setTimeout(() => {
                            this.showModal(modal.getAttribute('id'));
                        }, 5000);
                    }
                }
            }


            //Hide modal if user clicks area outside of modal box
            for(let modalBackground of this.modalBackgrounds)
            {
                modalBackground.addEventListener('click', event =>
                {
                    if(event.target === event.currentTarget)
                    {
                        this.hideModal();
                    }
                });
            }

            //Hide modal if user presses escape key
            document.addEventListener('keyup', function(event)
            {
                if(event.key === 'Escape')
                {
                    if(modal.activeModalExists())
                    {
                        modal.hideModal();
                    }
                }
            });
        },

        /*
        Show a modal

        @param {String} modalID - the id of the modal to show
        */
        showModal: function(modalID)
        {
            this.hideModal();


            //Show active modal
            if(document.getElementById(modalID))
            {
                document.getElementById(modalID).classList.add(modal.activeModalClass);
            }


            //If a Vimeo video exists play it
            let modalVimeoVideoID = document.getElementById(modalID).getAttribute('data-vimeo-modal-video-id');

            if(modalVimeoVideoID)
            {
                let player = new Vimeo.Player(modalVimeoVideoID);

                player.play();
            }
        },

        /*
        Hides any active modals
        */
        hideModal: function()
        {
            //Set a variable for the modal that was closed
            let closedModal = document.querySelector('.' + this.activeModalClass);

            if(closedModal)
            {
                //Hide the modal
                closedModal.classList.remove(this.activeModalClass);


                //If the modal is set to auto display, set local storage to hide it
                if(closedModal.getAttribute('data-modal-auto-display'))
                {
                    localStorage.setItem(closedModal.getAttribute('id') + '-closed', true);
                }
            }


            //Loop through Vimeo video modals and pause their Vimeo videos
            let modalWithVimeoVideos = document.querySelectorAll('.modal[data-vimeo-modal-video-id]');

            for(let modalWithVimeoVideo of modalWithVimeoVideos)
            {
                let player = new Vimeo.Player(modalWithVimeoVideo.querySelector('.modal__video').getAttribute('id'));

                player.pause();
            }
        },

        /*
        Shows the next modal if in a sequence of modals

        @param {String} modalID - the id of the modal to show
        */
        showNextModal: function(modalID)
        {
            const modalType = modalID.closest('.modal').getAttribute('data-category'),
                nextModalID = modalID.closest('.modal').nextElementSibling && modalID.closest('.modal').nextElementSibling.matches('.modal') ? modalID.closest('.modal').nextElementSibling.getAttribute('id') : '',
                firstModalID = document.querySelector('.modal[data-category=' + modalType + ']').getAttribute('id'),
                nextModal = nextModalID ? nextModalID : firstModalID;

            modal.hideModal();
            modal.showModal(nextModal);
        },

        /*
        Shows the previous modal if in a sequence of modals

        @param {String} modalID - the id of the modal to show
        */
        showPreviousModal: function(modalID)
        {
            const modalType = modalID.closest('.modal').getAttribute('data-category'),
                prevModalID = modalID.closest('.modal').previousElementSibling && modalID.closest('.modal').previousElementSibling.matches('.modal') ? modalID.closest('.modal').previousElementSibling.getAttribute('id') : '',
                lastModal = document.querySelectorAll('.modal[data-category=' + modalType + ']'),
                lastModalID = lastModal[lastModal.length -1].getAttribute('id'),
                PrevModal = prevModalID ? prevModalID : lastModalID;

            modal.hideModal();
            modal.showModal(PrevModal);
        },

        /*
        Detects whether an active modal exists
        */
        activeModalExists: function()
        {
            return document.querySelector('.' + this.activeModalClass) !== null;
        }
    };

    const ajaxPosts = {
        ajaxurl: "/wp-admin/admin-ajax.php",
        offset: 0,

        /*
        Returns WordPress posts via Ajax

        @param {Object} args - the args to pass into the method
        */
        getPosts: function(args)
        {
            ajaxPosts.postLimit = args['post_limit'] ? args['post_limit'] : '';

            args['post_limit'] = !args['post_limit'] ? ajaxPosts.postLimit : '';

            //Apply an offset to the posts returned if you're not replacing the existing posts (you don't want an offset if replacing them as you want the first x posts)
            if(args['replace_posts'])
            {
                ajaxPosts.offset = 0;
            }
            else
            {
                ajaxPosts.offset += args['post_limit'];
            }

            $.ajax({
                url: this.ajaxurl,
                data: {
                    action: args['php_callback_function'],
                    post_type: args['post_type'],
                    post_limit: args['post_limit'],
                    category: args['taxonomy_id'],
                    offset: this.offset,
                    user_location: args['user_location'],
                    user_age: args['user_age'],
                    event_type: args['event_type'],
                    team: args['team']
                },
                beforeSend:() =>
                {
                    if(document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-no-posts-error'))
                    {
                        document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-no-posts-error').classList.remove('alert--active');
                    }

                    if(!args['replace_posts'])
                    {
                        if(document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-pagination'))
                        {
                            document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-pagination').innerHTML = 'loading...';
                        }
                    }
                },
                success:(data) =>
                {
                    //Parse the JSON returned
                    let ajaxData = JSON.parse(data);

                    //If posts are returned, either append them or replace the current post data
                    if(ajaxData.total_posts > 0)
                    {
                        if(args['replace_posts'])
                        {
                            if(document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-card-container'))
                            {
                                document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-card-container').innerHTML = ajaxData.posts_html;
                            }

                            //Show the 'load more' button. If there are less total posts than the post limit set (e.g. the post limit is 10 but there's only 7 posts in total), this will hide again with the code a few lines below
                            if(document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-pagination'))
                            {
                                document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-pagination').style.display = 'inline-block';
                            }
                        }
                        else
                        {
                            if(document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-card-container'))
                            {
                                document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-card-container').insertAdjacentHTML('beforeend', ajaxData.posts_html);
                            }
                        }
                    }
                    //Else show no posts alert
                    else
                    {
                        if(document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-no-posts-error'))
                        {
                            document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-no-posts-error').classList.add('alert--active');
                        }
                    }

                    if(document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-pagination'))
                    {
                        document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-pagination').innerHTML = 'More';
                    }

                    //Hide more button if all posts are visible
                    if(document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-pagination') && document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-card-container').querySelectorAll('.card').length == ajaxData.total_posts)
                    {
                        document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-pagination').style.display = 'none';
                    }

                    //Hide loading spinner
                    if(document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-loading-spinner'))
                    {
                        document.getElementById(args['posts_wrapper_id']).querySelector('#ajax-cards-loading-spinner').classList.add('hidden');
                    }

                    //Show card carousel
                    if(document.getElementById(args['posts_wrapper_id']).querySelector('#book-event-card-carousel'))
                    {
                        document.getElementById(args['posts_wrapper_id']).querySelector('#book-event-card-carousel').classList.remove('hidden');
                    }
                }
            });
        }
    };

    const coachPortal = {
        eventIdField: document.getElementById('event-id-field') ? document.getElementById('event-id-field') : '',
        teamSelect: document.getElementById('coach-portal-team-select'),
        fixturePlayerSelects: document.getElementById('fixture-player-selects-container') ? document.getElementById('fixture-player-selects-container').querySelectorAll('select') : '',
        publishEventPostButton: document.getElementById('publish-post-button'),
        playerSelectionNotificationsEventPostButton: document.getElementById('send-player-selection-notifications-button'),
        deleteEventPostButton: document.getElementById('delete-post-button'),
        init()
        {
            //Get the list of players for an event when an age group and team has been selected
            if(this.teamSelect)
            {
                this.teamSelect.addEventListener('change', event =>
                {
                    this.setPlayerSelectOptions(this.getEventPlayers());
                });
            }

            //Set the player select options for an event
            if(this.fixturePlayerSelects)
            {
                this.setPlayerSelectOptions(this.getEventPlayers());


                //On select of an option, set all selected options to disabled on all player selects
                for(let fixturePlayerSelect of this.fixturePlayerSelects)
                {
                    fixturePlayerSelect.addEventListener('change', event =>
                    {
                        this.updateActiveSelectOptions(fixturePlayerSelect);
                    });
                }
            }

            //Publish an event on click of the publish event post button
            if(this.publishEventPostButton)
            {
                this.publishEventPostButton.addEventListener('click', event =>
                {
                    document.getElementById('post-action-hidden-field').value = 'publish';
                });
            }
            
            //Show confirmation alert when sending event player selection notifications
            if(this.playerSelectionNotificationsEventPostButton)
            {
                this.playerSelectionNotificationsEventPostButton.addEventListener('click', event =>
                {
                    if(!confirm("Are you sure you want to send notifications to players selected and not selected for this event?"))
                    {
                        event.preventDefault();
                    }
                });
            }
            
            //Show confirmation alert when deleting an event (moving post to trash)
            if(this.deleteEventPostButton)
            {
                this.deleteEventPostButton.addEventListener('click', event =>
                {
                    if(!confirm("Are you sure you want to delete this event? The event will be removed from all calendars and a cancellation notification will be sent to players."))
                    {
                        event.preventDefault();
                    }
                });
            }
        },

        /*
        Gets a list of players available for an event, based on the event age group and team

        @param {Object} args - options to pass to get the list of players
        */
        getEventPlayers: function()
        {
            //Get the team and age values from the select fields
            let args = {
                team_id: this.teamSelect.value,
                event_id: this.eventIdField ? this.eventIdField.value : ''
            };

            if(args['team_id'])
            {
                let httpRequest = new XMLHttpRequest(),
                    response = '';
        
                httpRequest.open('POST', '/wp-content/themes/bloomsburyfb/libs/coach-portal/get-team-event-players.php', false);
                httpRequest.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        
                httpRequest.onreadystatechange = () =>
                {
                    if(httpRequest.readyState === XMLHttpRequest.DONE && httpRequest.status === 200)
                    {
                        response = httpRequest.responseText;
                    }
                };
        
                httpRequest.send('team_id=' + args['team_id'] + '&event_id=' + args['event_id']);
                
                return JSON.parse(response);
            }
        },

        /*
        Sets the select options based on the list of players passed in

        @param {Object} players - a json list of player data to pass to the select
        */
        setPlayerSelectOptions: function(players)
        {
            if(players)
            {
                for(let [i, fixturePlayerSelect] of this.fixturePlayerSelects.entries())
                {
                    let selectNumber = parseInt(i + 1);

                    fixturePlayerSelect.length = 0;
                    
                    //Enable selects
                    fixturePlayerSelect.removeAttribute("disabled");

                    fixturePlayerSelect.options[fixturePlayerSelect.options.length] = new Option('Select Player #' + selectNumber, '');

                    //Set select options
                    for(let player of players)
                    {
                        fixturePlayerSelect.options[fixturePlayerSelect.options.length] = new Option(player.name, player.id);
                    }

                    //Set select selected option if the selects player id hidden field has a value (when editing an existing event post)
                    if(document.querySelector('input[name="player_' + selectNumber + '_id"]').value)
                    {
                        fixturePlayerSelect.value = document.querySelector('input[name="player_' + selectNumber + '_id"]').value;
                    }
                }
            }
        },

        /*
        Disable and enable player select options on change of a player select field
        */
        updateActiveSelectOptions: function(currentSelect)
        {
            let selectedPlayers = [];

            //Loop through player selects
            for(let fixturePlayerSelect of this.fixturePlayerSelects)
            {
                //If this select is not the currently selected select but the value is the same as the value jusr selected, set the value of the other select to blank so the same player can't be picked twice
                if(fixturePlayerSelect !== currentSelect && fixturePlayerSelect.value === currentSelect.value)
                {
                    fixturePlayerSelect.value = '';
                }


                //When a player is selected in any player select, add it to the selectedPlayers array
                if(fixturePlayerSelect.value)
                {
                    selectedPlayers.push(fixturePlayerSelect.value);
                }


                //For each select option for this select
                for(let fixturePlayerSelectOption of fixturePlayerSelect.options)
                {
                    //If the selectedPlayers array contains this player id and this selects value is blank (so we don't overwrite selects that have a player selected)
                    if(selectedPlayers.includes(fixturePlayerSelectOption.value) && fixturePlayerSelect.value == '')
                    {
                        //Disable this player's select option
                        fixturePlayerSelectOption.disabled = true;
                    }
                    else
                    {
                        //Enable this player's select option
                        fixturePlayerSelectOption.disabled = false;
                    }
                }
            }
        }
    };

    const misc = {
        //Paid events (WooCommerce)
        wcProductPaymentTermsSelect: document.getElementById('pa_payment-terms'),
        wcProductPlayerAttendingSelect: document.getElementById('event-booking-player-attending-select'),
        nonTeamEventWaitingListSubmitButton: document.getElementById('non-team-event-waiting-list-button'),
        nonTeamEventInterestListSubmitButton: document.getElementById('non-team-event-interest-list-button'),
        nonTeamEventInterestListModalButton: document.getElementById('non-team-event-interest-list-modal-button'),
        subscriptionCancellationSubmitButton: document.getElementById('subscription-cancellation-form-button'),
        nonTeamEventBookTasterSubmitButton: document.getElementById('non-team-event-taster-booking-button'),
        nonTeamEventAddPlayerSubmitButton: document.getElementById('non-team-event-add-player-button'),
        nonTeamEventCancelTasterSubmitButtons: document.querySelectorAll('.non-team-event-taster-cancel-button'),
        nonTeamEventWaitingListModalButton: document.getElementById('non-team-event-waiting-list-modal-button'),
        nonTeamEventSignedOutButtons: document.querySelectorAll('[data-signedout-event-button="true"'),
        //Team event
        teamEventNotAttendingButton: document.getElementById('team-event-not-attending-button'),
        teamEventAttendanceSelect: document.getElementById('team-event-attendance-select'),
        teamEventAttendanceSelectOuter: document.getElementById('team-event-attendance-select-outer'),
        //Parent portal
        signInModal: document.getElementById('parent-portal-login-modal'),
        bookASessionSection: document.getElementById('book-an-event-section'),
        trialAttendanceSelect: document.getElementById('trial-attendance-select'),
        bookASessionAgeSelect: document.getElementById('book-event-age-filter'),
        bookATrialPreferredTeamSelect: document.getElementById('player-trial-preferred-team-select'),
        bookATrialClubFootballGenderField: document.getElementById('player-trial-club-football-gender-field'),
        bookATrialBoysTeamAgeSelect: document.getElementById('boys-football-age'),
        addPlayerButton: document.getElementById('player-portal-add-player-button'),
        addPlayerCopyParentAddressCheckbox: document.getElementById('player-address-copy-from-parent'),
        locationTypeahead: document.getElementById('location-typeahead'),
        financialAssistanceForm: document.getElementById('financial-assistance-form'),
        //Misc
        cardsWithFlipContent: document.querySelectorAll('.card--flip-content'),
        cardswithExpandableContent: document.querySelectorAll('.card--expandable-content'),
        cookieNoticeButton: document.getElementById('cookie-notice-button'),
        init()
        {
            //Set the input to a Google Places Autocomplete typeahead
            if(this.locationTypeahead)
            {
                const autocomplete = new google.maps.places.Autocomplete(this.locationTypeahead, {
                    componentRestrictions: { country: "uk" },
                    strictBounds: false
                });
                
                //On select of a location
                autocomplete.addListener("place_changed", () =>
                {
                    const place = autocomplete.getPlace();

                    //Set the latitude hidden field value
                    if(document.getElementById('location-typeahead-lat'))
                    {
                        document.getElementById('location-typeahead-lat').value = place.geometry.location.lat();
                    }
                    
                    //Set the longitude hidden field value
                    if(document.getElementById('location-typeahead-lng'))
                    {
                        document.getElementById('location-typeahead-lng').value = place.geometry.location.lng();
                    }
                });
            }


            //Close cookie notice on click of button
            if(this.cookieNoticeButton)
            {
                this.cookieNoticeButton.addEventListener('click', () =>
                {
                    this.acceptCookiesAndHideNotice();
                });
            }


            //Show the player select field when a user selects their payment term on a subscription product
            if(this.wcProductPaymentTermsSelect)
            {
                this.wcProductPaymentTermsSelect.addEventListener('change', () =>
                {
                    if(document.getElementById('player-attending-field'))
                    {
                        if(this.wcProductPaymentTermsSelect.value)
                        {
                            document.getElementById('player-attending-field').classList.remove('hidden');
                        }
                        else
                        {
                            document.getElementById('player-attending-field').classList.add('hidden');
                        }
                    }
                });
            }


            //Show/hide sepcific fields in book a trial process depending on selections
            if(this.bookATrialClubFootballGenderField)
            {
                this.bookATrialClubFootballGenderField.addEventListener('change', (event) =>
                {
                    if(event.target.value == 'Boys')
                    {
                        if(document.getElementById('boys-football-statement'))
                        {
                            document.getElementById('boys-football-statement').classList.remove('hidden');
                        }
                        
                        if(document.getElementById('girls-football-statement'))
                        {
                            document.getElementById('girls-football-statement').classList.add('hidden');
                        }
                    }
                    else if(event.target.value == 'Girls')
                    {
                        if(document.getElementById('boys-football-statement'))
                        {
                            document.getElementById('boys-football-statement').classList.add('hidden');
                        }

                        if(document.getElementById('girls-football-statement'))
                        {
                            document.getElementById('girls-football-statement').classList.remove('hidden');
                        }
                    }
                });
            }

            if(this.bookATrialPreferredTeamSelect)
            {
                this.bookATrialPreferredTeamSelect.addEventListener('change', (event) =>
                {
                    if(event.target.value === 'Club Football')
                    {
                        if(document.getElementById('player-trial-club-football-fields'))
                        {
                            document.getElementById('player-trial-club-football-fields').classList.remove('hidden');
                        }

                        if(document.getElementById('player-trial-club-futsal-fields'))
                        {
                            document.getElementById('player-trial-club-futsal-fields').classList.add('hidden');
                        }
                    }
                    else if(event.target.value === 'Club Futsal')
                    {
                        if(document.getElementById('player-trial-club-football-fields'))
                        {
                            document.getElementById('player-trial-club-football-fields').classList.add('hidden');
                        }

                        if(document.getElementById('player-trial-club-futsal-fields'))
                        {
                            document.getElementById('player-trial-club-futsal-fields').classList.remove('hidden');
                        }
                    }
                });
            }
            

            //add the player attending WordPress post id to a hidden field when a user selects a player for an event
            if(this.wcProductPlayerAttendingSelect)
            {
                this.wcProductPlayerAttendingSelect.addEventListener('change', () =>
                {
                    let playerPostId = this.wcProductPlayerAttendingSelect.querySelector(':checked').getAttribute('data-player-post-id');

                    if(document.getElementById('event-booking-player-attending-post-id-field'))
                    {
                        document.getElementById('event-booking-player-attending-post-id-field').value = playerPostId;
                    }
                });
            }


            //Show the event attendance modal when a user selects they can't make a team event
            if(this.teamEventAttendanceSelect)
            {
                this.teamEventAttendanceSelect.addEventListener('change', () =>
                {
                    if(this.teamEventAttendanceSelect.value === 'not-attending')
                    {
                        modal.showModal('event-not-attending-modal');
                    }
                });
            }


            //Show the 'not attending' field if a user selects they can't make a trial
            if(this.trialAttendanceSelect)
            {
                this.trialAttendanceSelect.addEventListener('change', () =>
                {
                    if(this.trialAttendanceSelect.value === 'attending' && document.getElementById('trial-not-attending-field'))
                    {
                        document.getElementById('trial-not-attending-field').classList.add('hidden');
                        document.getElementById('trial-attendance-notes').disabled = true;
                    }
                    else
                    {
                        document.getElementById('trial-not-attending-field').classList.remove('hidden');
                        document.getElementById('trial-attendance-notes').disabled = false;
                    }
                });
            }


            //Validate the not attending form and disable the attending select
            if(this.teamEventNotAttendingButton)
            {
                this.teamEventNotAttendingButton.addEventListener('click', (event) =>
                {
                    event.preventDefault();

                    if(form.validateFormsFields(this.teamEventNotAttendingButton.closest('.form')) === 'success')
                    {
                        form.submitForm(this.teamEventNotAttendingButton.closest('.form'), true);
                        
                        this.teamEventAttendanceSelectOuter.classList.add('button--disabled');
                        this.teamEventAttendanceSelect.disabled = true;

                        if(document.getElementById('fixture-status-label-not-attending'))
                        {
                            document.getElementById('fixture-status-label-not-attending').classList.remove('hidden');
                        }

                        if(document.getElementById('fixture-status-label-attending'))
                        {
                            document.getElementById('fixture-status-label-attending').classList.add('hidden');
                        }
                    }
                });
            }


            //Validate the not attending form and disable the attending select
            if(this.nonTeamEventWaitingListSubmitButton)
            {
                this.nonTeamEventWaitingListSubmitButton.addEventListener('click', (event) =>
                {
                    //Fix for IE as event.preventDefault is not supported
                    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

                    if(form.validateFormsFields(this.nonTeamEventWaitingListSubmitButton.closest('.form')) === 'success')
                    {
                        form.submitForm(this.nonTeamEventWaitingListSubmitButton.closest('.form'), true);
                        
                        this.nonTeamEventWaitingListModalButton.disabled = true;
                    }
                });
            }


            //Validate the not attending form and disable the attending select
            if(this.nonTeamEventInterestListSubmitButton)
            {
                this.nonTeamEventInterestListSubmitButton.addEventListener('click', (event) =>
                {
                    //Fix for IE as event.preventDefault is not supported
                    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

                    if(form.validateFormsFields(this.nonTeamEventInterestListSubmitButton.closest('.form')) === 'success')
                    {
                        form.submitForm(this.nonTeamEventInterestListSubmitButton.closest('.form'), true);

                        if(document.getElementById('event-interest-list-modal-form'))
                        {
                            document.getElementById('event-interest-list-modal-form').classList.add('hidden');
                        }
                        
                        if(this.nonTeamEventWaitingListModalButton)
                        {
                            this.nonTeamEventWaitingListModalButton.disabled = true;
                        }
                    }
                });
            }


            //Validate the subscription cancellation form
            if(this.subscriptionCancellationSubmitButton)
            {
                this.subscriptionCancellationSubmitButton.addEventListener('click', (event) =>
                {
                    //Fix for IE as event.preventDefault is not supported
                    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

                    if(form.validateFormsFields(this.subscriptionCancellationSubmitButton.closest('.form')) === 'success')
                    {
                        form.submitForm(this.subscriptionCancellationSubmitButton.closest('.form'), true);
                        
                        this.subscriptionCancellationSubmitButton.disabled = true;
                    }
                });
            }


            //Validate the 'book a taster' form
            if(this.nonTeamEventBookTasterSubmitButton)
            {
                this.nonTeamEventBookTasterSubmitButton.addEventListener('click', (event) =>
                {
                    //Fix for IE as event.preventDefault is not supported
                    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

                    if(form.validateFormsFields(this.nonTeamEventBookTasterSubmitButton.closest('.form')) === 'success')
                    {
                        form.submitForm(this.nonTeamEventBookTasterSubmitButton.closest('.form'), true);
                    }
                });
            }


            //Validate the 'add a player' form
            if(this.nonTeamEventAddPlayerSubmitButton)
            {
                this.nonTeamEventAddPlayerSubmitButton.addEventListener('click', (event) =>
                {
                    //Fix for IE as event.preventDefault is not supported
                    event.preventDefault ? event.preventDefault() : (event.returnValue = false);

                    if(form.validateFormsFields(this.nonTeamEventAddPlayerSubmitButton.closest('.form')) === 'success')
                    {
                        form.submitForm(this.nonTeamEventAddPlayerSubmitButton.closest('.form'), true);

                        location.reload();
                    }
                });
            }


            //Show prompt on submit of the 'cancel a taster' form
            if(this.nonTeamEventCancelTasterSubmitButtons)
            {
                for(let nonTeamEventCancelTasterSubmitButton of this.nonTeamEventCancelTasterSubmitButtons)
                {
                    nonTeamEventCancelTasterSubmitButton.addEventListener('click', (event) =>
                    {
                        //If the user confirms they want to cancel
                        if(confirm("Are you sure you want to cancel this taster booking?"))
                        {
                            //Submit form to reset players taster fields
                            form.submitForm(nonTeamEventCancelTasterSubmitButton.closest('.form'), true);

                            //Hide the listing
                            if(nonTeamEventCancelTasterSubmitButton.closest('.listing'))
                            {
                                nonTeamEventCancelTasterSubmitButton.closest('.listing').classList.add('listing--deactive');
                            }
                        }
                        else
                        {
                            return false;
                        }

                    });
                }
            }


            //Loop through signed out event buttons such as 'add to basket', 'book a taster'
            if(this.nonTeamEventSignedOutButtons)
            {
                for(let nonTeamEventSignedOutButton of this.nonTeamEventSignedOutButtons)
                {
                    //On click, set the log in url referer to the products url
                    nonTeamEventSignedOutButton.addEventListener('click', (event) =>
                    {
                        let productBookUrl = nonTeamEventSignedOutButton.getAttribute('data-referer-url'),
                            modalTitle = nonTeamEventSignedOutButton.getAttribute('data-modal-title');

                        //Set the redirect_to hidden field to the product url in the 'sign in' part of the sign in modal
                        if(this.signInModal && productBookUrl)
                        {
                            this.signInModal.querySelector("input[name='redirect_to']").value = productBookUrl;
                        }
                        
                        //Set the href to the product url in the 'register' part of the sign in modal
                        if(this.signInModal && this.signInModal.querySelector('#sign-in-modal-register-button'))
                        {
                            this.signInModal.querySelector('#sign-in-modal-register-button').href = this.signInModal.querySelector('#sign-in-modal-register-button').href + '?redirect_to=' + productBookUrl;
                        }
                        
                        //If a modal title is set, change the title of the sign in modal title to that
                        if(modalTitle && this.signInModal.querySelector('#parent-portal-login-modal-title'))
                        {
                            this.signInModal.querySelector('#parent-portal-login-modal-title').innerHTML = modalTitle;
                        }
                        
                        //Prevent login form from being submitted if the username and password fields are empty
                        if(this.signInModal && this.signInModal.querySelector('#loginform'))
                        {
                            this.signInModal.querySelector('#loginform').addEventListener('submit', (event) =>
                            {
                                if(this.signInModal.querySelector('#user_login').value === '' && this.signInModal.querySelector('#user_pass').value === '')
                                {
                                    event.preventDefault();
                                }
                            });
                        }
                    });
                }
            }


            //Get the book a session events by age
            if(this.bookASessionAgeSelect)
            {
                this.bookASessionAgeSelect.addEventListener('change', event =>
                {
                    event.preventDefault();

                    this.getBookSessionEvents({age: this.bookASessionAgeSelect.value});
                });
            }


            //Flip content on click of CTA button for cards with extra content
            if(this.cardsWithFlipContent)
            {
                for(let cardWithFlipContent of this.cardsWithFlipContent)
                {
                    if(cardWithFlipContent.querySelector('.card__cta'))
                    {
                        cardWithFlipContent.querySelector('.card__cta').addEventListener('click', event =>
                        {
                            event.stopPropagation();
        
                            cardWithFlipContent.classList.add('card--active');
                        });
                    }

                    if(cardWithFlipContent.querySelector('.card__back__cta'))
                    {
                        cardWithFlipContent.querySelector('.card__back__cta').addEventListener('click', event =>
                        {
                            event.stopPropagation();
        
                            cardWithFlipContent.classList.remove('card--active');
                        });
                    }
                }
            }


            //Display content on click of CTA button for cards with extra content
            if(this.cardswithExpandableContent)
            {
                for(let cardWithExpandableContent of this.cardswithExpandableContent)
                {
                    if(cardWithExpandableContent.querySelector('.card__cta'))
                    {
                        cardWithExpandableContent.querySelector('.card__cta').addEventListener('click', event =>
                        {
                            event.stopPropagation();

                            cardWithExpandableContent.classList.add('card--active');
                        });
                    }

                    if(cardWithExpandableContent.querySelector('.card__back'))
                    {
                        cardWithExpandableContent.querySelector('.card__back').addEventListener('click', event =>
                        {
                            event.stopPropagation();
        
                            cardWithExpandableContent.classList.remove('card--active');
                        });
                    }
                }
            }


            //Show's the 'add player' form in the parent portal
            if(this.addPlayerButton)
            {
                this.addPlayerButton.addEventListener('click', () =>
                {
                    document.getElementById('player-portal-add-player-form').classList.toggle('hidden');
                });
            }


            //Copy parents address details on click of the checkbox in the 'add player' form
            if(this.addPlayerCopyParentAddressCheckbox && document.querySelector('form.edit-account'))
            {
                this.addPlayerCopyParentAddressCheckbox.addEventListener('click', () =>
                {
                    if(this.addPlayerCopyParentAddressCheckbox.checked)
                    {
                        if(document.getElementById('address-line-1-field') && document.querySelector('form.edit-account').querySelector('#address_line_1'))
                        {
                            document.getElementById('address-line-1-field').value = document.querySelector('form.edit-account').querySelector('#address_line_1').value;
                        }
                        if(document.getElementById('address-line-2-field') && document.querySelector('form.edit-account').querySelector('#address_line_2'))
                        {
                            document.getElementById('address-line-2-field').value = document.querySelector('form.edit-account').querySelector('#address_line_2').value;
                        }
                        if(document.getElementById('address-town-city-field') && document.querySelector('form.edit-account').querySelector('#town_city'))
                        {
                            document.getElementById('address-town-city-field').value = document.querySelector('form.edit-account').querySelector('#town_city').value;
                        }
                        if(document.getElementById('address-borough-field') && document.querySelector('form.edit-account').querySelector('#borough'))
                        {
                            document.getElementById('address-borough-field').value = document.querySelector('form.edit-account').querySelector('#borough').value;

                            //Show address borough 'other' field if value of borough field is set to other
                            if(document.getElementById('address-borough-other-field') && document.getElementById('new-player-borough-other-field') && document.querySelector('form.edit-account').querySelector('#borough') && document.querySelector('form.edit-account').querySelector('#borough-other') && document.getElementById('address-borough-field').value === 'Other')
                            {
                                document.getElementById('new-player-borough-other-field').classList.remove('hidden');

                                document.getElementById('address-borough-other-field').value = document.querySelector('form.edit-account').querySelector('#borough-other').value;
                            }
                        }
                        if(document.getElementById('address-county-field') && document.querySelector('form.edit-account').querySelector('#county'))
                        {
                            document.getElementById('address-county-field').value = document.querySelector('form.edit-account').querySelector('#county').value;
                        }
                        if(document.getElementById('address-country-field') && document.querySelector('form.edit-account').querySelector('#country'))
                        {
                            document.getElementById('address-country-field').value = document.querySelector('form.edit-account').querySelector('#country').value;
                        }
                        if(document.getElementById('home-postcode-field') && document.querySelector('form.edit-account').querySelector('#postcode'))
                        {
                            document.getElementById('home-postcode-field').value = document.querySelector('form.edit-account').querySelector('#postcode').value;
                        }
                    }
                    else
                    {
                        if(document.getElementById('address-line-1-field') && document.querySelector('form.edit-account').querySelector('#address_line_1'))
                        {
                            document.getElementById('address-line-1-field').value = '';
                        }
                        if(document.getElementById('address-line-2-field') && document.querySelector('form.edit-account').querySelector('#address_line_2'))
                        {
                            document.getElementById('address-line-2-field').value = '';
                        }
                        if(document.getElementById('address-town-city-field') && document.querySelector('form.edit-account').querySelector('#town_city'))
                        {
                            document.getElementById('address-town-city-field').value = '';
                        }
                        if(document.getElementById('address-borough-field') && document.querySelector('form.edit-account').querySelector('#borough'))
                        {
                            document.getElementById('address-borough-field').value = '';

                            //Show address borough 'other' field if value of borough field is set to other
                            if(document.getElementById('address-borough-other-field') && document.getElementById('new-player-borough-other-field') && document.querySelector('form.edit-account').querySelector('#borough') && document.querySelector('form.edit-account').querySelector('#borough-other'))
                            {
                                document.getElementById('new-player-borough-other-field').classList.add('hidden');

                                document.getElementById('address-borough-other-field').value = '';
                            }
                        }
                        if(document.getElementById('address-county-field') && document.querySelector('form.edit-account').querySelector('#county'))
                        {
                            document.getElementById('address-county-field').value = '';
                        }
                        if(document.getElementById('address-country-field') && document.querySelector('form.edit-account').querySelector('#country'))
                        {
                            document.getElementById('address-country-field').value = '';
                        }
                        if(document.getElementById('home-postcode-field') && document.querySelector('form.edit-account').querySelector('#postcode'))
                        {
                            document.getElementById('home-postcode-field').value = '';
                        }
                    }
                });
            }


            //Submit the standalone financial assitance form when the user clicks yes or no
            if(this.financialAssistanceForm)
            {
                // if(this.financialAssistanceForm.querySelector('#refugee_or_asylum_seeker_yes'))
                // {
                //     this.financialAssistanceForm.querySelector('#refugee_or_asylum_seeker_yes').addEventListener('click', () =>
                //     {
                //         this.financialAssistanceForm.submit();
                //     });
                // }
                
                if(this.financialAssistanceForm.querySelector('#refugee_or_asylum_seeker_yes'))
                {
                    this.financialAssistanceForm.querySelector('#refugee_or_asylum_seeker_yes').addEventListener('click', () =>
                    {
                        if(this.financialAssistanceForm.querySelector('#eligible_universal_credit_field'))
                        {
                            this.financialAssistanceForm.querySelector('#eligible_universal_credit_field').classList.add('hidden');
                            this.financialAssistanceForm.querySelector('#eligible_universal_credit_yes').classList.remove('form__field-required');
                            this.financialAssistanceForm.querySelector('#eligible_universal_credit_no').classList.remove('form__field-required');
                        }
                    });
                }
                
                if(this.financialAssistanceForm.querySelector('#refugee_or_asylum_seeker_no'))
                {
                    this.financialAssistanceForm.querySelector('#refugee_or_asylum_seeker_no').addEventListener('click', () =>
                    {
                        if(this.financialAssistanceForm.querySelector('#eligible_universal_credit_field'))
                        {
                            this.financialAssistanceForm.querySelector('#eligible_universal_credit_field').classList.remove('hidden');
                            this.financialAssistanceForm.querySelector('#eligible_universal_credit_yes').classList.add('form__field-required');
                            this.financialAssistanceForm.querySelector('#eligible_universal_credit_no').classList.add('form__field-required');
                        }
                    });
                }
                
                // if(this.financialAssistanceForm.querySelector('#eligible_universal_credit_yes'))
                // {
                //     this.financialAssistanceForm.querySelector('#eligible_universal_credit_yes').addEventListener('click', () =>
                //     {
                //         this.financialAssistanceForm.submit();
                //     });
                // }
                
                if(this.financialAssistanceForm.querySelector('#refugee_or_asylum_seeker_yes') || this.financialAssistanceForm.querySelector('#eligible_universal_credit_yes'))
                {
                    for(let refugeeOrUniversalCreditField of this.financialAssistanceForm.querySelectorAll('#refugee_or_asylum_seeker_yes, #eligible_universal_credit_yes'))
                    {
                        refugeeOrUniversalCreditField.addEventListener('click', () =>
                        {
                            if(this.financialAssistanceForm.querySelector('#household_income_container'))
                            {
                                this.financialAssistanceForm.querySelector('#household_income_container').classList.add('hidden');
                            }

                            if(this.financialAssistanceForm.querySelector('#household_income'))
                            {
                                this.financialAssistanceForm.querySelector('#household_income').disabled = true;
                            }

                            if(this.financialAssistanceForm.querySelector('#people_in_household_container'))
                            {
                                this.financialAssistanceForm.querySelector('#people_in_household_container').classList.add('hidden');
                            }

                            if(this.financialAssistanceForm.querySelector('#people_in_household'))
                            {
                                this.financialAssistanceForm.querySelector('#people_in_household').disabled = true;
                            }
                        });
                    }
                }
                
                if(this.financialAssistanceForm.querySelector('#eligible_universal_credit_no'))
                {
                    this.financialAssistanceForm.querySelector('#eligible_universal_credit_no').addEventListener('click', () =>
                    {
                        if(this.financialAssistanceForm.querySelector('#household_income_container'))
                        {
                            this.financialAssistanceForm.querySelector('#household_income_container').classList.remove('hidden');
                        }

                        if(this.financialAssistanceForm.querySelector('#household_income'))
                        {
                            this.financialAssistanceForm.querySelector('#household_income').disabled = false;
                        }

                        if(this.financialAssistanceForm.querySelector('#people_in_household_container'))
                        {
                            this.financialAssistanceForm.querySelector('#people_in_household_container').classList.remove('hidden');
                        }

                        if(this.financialAssistanceForm.querySelector('#people_in_household'))
                        {
                            this.financialAssistanceForm.querySelector('#people_in_household').disabled = false;
                        }
                    });
                }
                

                // if(this.financialAssistanceForm.querySelector('#require_financial_assistance_yes'))
                // {
                //     this.financialAssistanceForm.querySelector('#require_financial_assistance_yes').addEventListener('click', () =>
                //     {
                //         this.financialAssistanceForm.submit();
                //     });
                // }

                // if(this.financialAssistanceForm.querySelector('#require_financial_assistance_no'))
                // {
                //     this.financialAssistanceForm.querySelector('#require_financial_assistance_no').addEventListener('click', () =>
                //     {
                //         this.financialAssistanceForm.submit();
                //     });
                // }
            }        

            //Get the book a session events
            this.getBookSessionEvents();
        },

        /*
        Sets the events for the book a session section

        @param {Object} args - options to pass to book events initialisation
        */
        getBookSessionEvents: function(args)
        {
            if(this.bookASessionSection)
            {
                //Show loading spinner
                if(document.getElementById('book-event-card-wrapper').querySelector('#ajax-cards-loading-spinner'))
                {
                    document.getElementById('book-event-card-wrapper').querySelector('#ajax-cards-loading-spinner').classList.remove('hidden');
                }

                //Hide card carousel
                if(document.getElementById('book-event-card-wrapper').querySelector('#book-event-card-carousel'))
                {
                    document.getElementById('book-event-card-wrapper').querySelector('#book-event-card-carousel').classList.add('hidden');
                }

                let user_location = {};

                //Get users location via Geolocation
                if(navigator.geolocation)
                {
                    navigator.geolocation.getCurrentPosition(
                        (position) =>
                        {
                            user_location = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            };

                            let postArgs = {
                                'php_callback_function': 'get_book_event_cards_via_ajax',
                                'posts_wrapper_id': 'book-event-card-wrapper',
                                'post_type': 'product',
                                'post_limit': 10,
                                'user_age': args && args['age'] ? args['age'] : '',
                                'event_type': document.getElementById('book-session-event-type-id') ? document.getElementById('book-session-event-type-id').innerHTML : '',
                                'team': document.getElementById('book-session-team-id') ? document.getElementById('book-session-team-id').innerHTML : '',
                                'user_location': user_location,
                                'replace_posts': true
                            };
                            ajaxPosts.getPosts(postArgs);


                            //If slick has not been initialised before, init the carousel
                            if(!document.getElementById('book-event-card-carousel').querySelector('.carousel__inner').classList.contains('slick-initialized'))
                            {
                                this.initBookSessionCarousel();
                            }
                        },
                        () =>
                        {
                            let postArgs = {
                                'php_callback_function': 'get_book_event_cards_via_ajax',
                                'posts_wrapper_id': 'book-event-card-wrapper',
                                'post_type': 'product',
                                'post_limit': 10,
                                'user_age': args && args['age'] ? args['age'] : '',
                                'event_type': document.getElementById('book-session-event-type-id') ? document.getElementById('book-session-event-type-id').innerHTML : (args && args['event_type'] ? args['event_type'] : ''),
                                'team': document.getElementById('book-session-team-id') ? document.getElementById('book-session-team-id').innerHTML : (args && args['team'] ? args['team'] : ''),
                                'replace_posts': true
                            };
                            ajaxPosts.getPosts(postArgs);


                            //If slick has not been initialised before, init the carousel
                            if(!document.getElementById('book-event-card-carousel').querySelector('.carousel__inner').classList.contains('slick-initialized'))
                            {
                                this.initBookSessionCarousel();
                            }
                        }
                    );
                }
                else
                {
                    let postArgs = {
                        'php_callback_function': 'get_book_event_cards_via_ajax',
                        'posts_wrapper_id': 'book-event-card-wrapper',
                        'post_type': 'product',
                        'post_limit': 10,
                        'user_age': args && args['age'] ? args['age'] : '',
                        'event_type': document.getElementById('book-session-event-type-id') ? document.getElementById('book-session-event-type-id').innerHTML : '',
                        'team': document.getElementById('book-session-team-id') ? document.getElementById('book-session-team-id').innerHTML : '',
                        'replace_posts': true
                    };
                    ajaxPosts.getPosts(postArgs);


                    //If slick has not been initialised before, init the carousel
                    if(!document.getElementById('book-event-card-carousel').querySelector('.carousel__inner').classList.contains('slick-initialized'))
                    {
                        this.initBookSessionCarousel();
                    }
                }
            }
        },

        //Reset Slick on the book a session cards
        destroyBookSessionCarousel: function()
        {
            //If slick has been initialised before, remove the previous slick slides and reset slick
            if(document.getElementById('book-event-card-carousel').querySelector('.carousel__inner').classList.contains('slick-initialized'))
            {
                $(document.getElementById('book-event-card-carousel').querySelector('.carousel__inner')).slick('slickRemove', null, null, true);

                $(document.getElementById('book-event-card-carousel').querySelector('.carousel__inner')).slick('unslick');
            }
        },

        //Initialises the book a session section card carousel
        initBookSessionCarousel: function()
        {
            $(document).ajaxComplete(() =>
            {
                this.destroyBookSessionCarousel();

                carousel.loadBookSessionCarousel();
            });
        },

        //Accepts cookies and hide the cookie notice
        acceptCookiesAndHideNotice: function()
        {
            document.getElementById('cookie-notice').style.display = 'none';
            document.cookie = "accept-cookies=1; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        },

        //Accepts cookies and hide the cookie notice
        getCookieValue: function(name)
        {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts.length === 2) return parts.pop().split(';').shift();
        }
    };

    const eventMapSearch =
    {
        eventsReturnedPostIds: [],
        eventSearchSection: document.getElementById('event-search-section'),
        eventSearchMap: document.getElementById('event-search-map'),
        eventSearchMapZoomInButton: document.getElementById('event-search-map-zoom-in'),
        eventSearchMapZoomOutButton: document.getElementById('event-search-map-zoom-out'),
        eventSearchForm: document.getElementById('event-search-form'),
        eventSearchFaYesCheckbox: document.getElementById('require_financial_assistance_yes'),
        eventSearchPostcodeInput: document.getElementById('event-search-postcode-field'),
        eventSearchOverlay: document.getElementById('event-search-loading-overlay'),
        eventSearchFinancialAssistanceModalForm: document.getElementById('financial-assistance-modal-form'),
        eventListingsWrapper: document.getElementById('event-locations-list'),
        noEventListingsAlert: document.getElementById('no-event-locations-alert'),
        eventListings: document.querySelectorAll('#event-locations-list .listing'),
        eventDetailsWrapper: document.getElementById('event-location-details'),
        backtoAllEventsWrapper: document.getElementById('all-events-back'),
        backtoAllEventsButton: document.getElementById('all-events-back-button'),
        eventDetailsListings: document.querySelectorAll('#event-location-details .event-details-section'),
        icon: null,
        infowindow: new google.maps.InfoWindow(),
        bounds: null,
        map: null,
        markers: [],

        /*
        Initialization on page load
        */
        init()
        {
            //Set up the map
            if(this.eventSearchMap)
            {
                if(this.eventSearchPostcodeInput && this.eventSearchPostcodeInput.value)
                {
                    this.convertSearchPostcodeToLatLng(this.eventSearchPostcodeInput.value);
                }
                else
                {
                    this.initMap(true);
                }
            }


            //Update the events on submit of the event search form
            if(this.eventSearchForm)
            {
                this.eventSearchForm.addEventListener('submit', event =>
                {
                    event.preventDefault();

                    
                    //Set selected_event_location_postcode value to blank on submit of the form, to reset the postcode set here when a user selects a location
                    document.getElementById('selected-event-location-postcode').value = '';


                    //If the user has selected they need financial assistance, show that modal
                    // if(this.eventSearchFaYesCheckbox && this.eventSearchFaYesCheckbox.checked)
                    // {
                    //     // if(!misc.getCookieValue('financial-assistance-level') || misc.getCookieValue('financial-assistance-level') === '0')
                    //     // {
                    //         modal.showModal('financial-assistance-modal');
                    //     // }
                    // }
                    // //else set our fa cookie to 0
                    // else
                    // {
                    //     document.cookie = "financial-assistance-level=0; path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT";
                    // }


                    //Get the lat and lng values for the location entered and set the hidden form fields
                    if(this.eventSearchPostcodeInput && this.eventSearchPostcodeInput.value)
                    {
                        this.convertSearchPostcodeToLatLng(this.eventSearchPostcodeInput.value);
                    }
                    //Else set the hidden form fields to blank
                    else
                    {
                        //Set the latitude hidden field value
                        if(document.getElementById('event-postcode-lat'))
                        {
                            document.getElementById('event-postcode-lat').value = '';
                        }
                    
                        //Set the longitude hidden field value
                        if(document.getElementById('event-postcode-lng'))
                        {
                            document.getElementById('event-postcode-lng').value = '';
                        }

                        this.initMap(false);
                    }
                    
                    //this.pushstateFormFieldData();


                    //Scroll down to event search section
                    this.eventSearchSection.scrollIntoView({behavior: "smooth", block: "start"});
                });
            }


            //Reset the search on click of the back button
            if(this.backtoAllEventsButton)
            {
                this.backtoAllEventsButton.addEventListener('click', event =>
                {
                    document.getElementById('selected-event-location-postcode').value = '';
                    
                    this.initMap(false, '', false);
                });
            }


            //Zoom the map in on click of the icon
            if(this.eventSearchMapZoomInButton)
            {
                this.eventSearchMapZoomInButton.addEventListener('click', event =>
                {
                    this.map.setZoom(this.map.getZoom() + 1);
                });
            }


            //Zoom the map out on click of the icon
            if(this.eventSearchMapZoomOutButton)
            {
                this.eventSearchMapZoomOutButton.addEventListener('click', event =>
                {
                    this.map.setZoom(this.map.getZoom() - 1);
                });
            }

            //Loop through event listings
            for(let eventListing of this.eventListings)
            {
                //Hide location if they are not returned after a search
                let eventListingPostcode = eventListing.getAttribute('data-postcode');

                eventListing.addEventListener("click", () =>
                {
                    this.selectLocation(eventListingPostcode);
                });
            }
        },

        /*
        Sets up the map

        @param {Boolean} pageRefreshed - whether the page has been refreshed or not
        @param (String) eventLocationEndpointParams - params passed to the event locations endpoint in order to refine the results, e.g. pass postcode to return location with that postcode only
        @param (Boolean) userSearchedLocation - whether the user searched for a location. If so, return the nearest location to their location
        @param (Boolean) userClickedLocation - whether the user clicked a location. If so, show/hide the relevant wrappers
        */
        initMap: function(pageRefreshed, eventLocationEndpointParams, userSearchedLocation, userClickedLocation)
        {
            //Show loading overlay
            if(this.eventSearchOverlay)
            {
                this.eventSearchOverlay.classList.add('loading-overlay--active');
            }


            //Set lat and long of map
            let lat = this.eventSearchMap.getAttribute('data-lat'),
                lng = this.eventSearchMap.getAttribute('data-lng');


            //Create infowindow object
            this.infowindow =  new google.maps.InfoWindow({});


            //Initialise the map
            this.map = new google.maps.Map(this.eventSearchMap, {
                zoom: 12,
                center: new google.maps.LatLng(lat, lng),
                mapTypeControl: false,
                zoomControl: false,
                streetViewControl: false,
                fullscreenControlOptions: {
                    position: google.maps.ControlPosition.BOTTOM_LEFT
                }
            });


            //Set the map to zoom out so all markers show by default
            let bounds = new google.maps.LatLngBounds();


            //Get an array of event locations returned
            let eventLocations = this.getEventLocationData(eventLocationEndpointParams);


            //Set an event location postcodes array, used to build up a list of postcodes returned used to show/hide the locations in the listings via checking data attr
            let eventLocationPostcodes = [];


            //Set an event location product id's array, used to build up a list of product ids returned used to show/hide the relevant products in the listings via checking data attr
            let eventLocationProductIds = [];

            //If the map is called without a page refresh (on change of a form field)
            if(!pageRefreshed)
            {
                //If events are returned
                if(eventLocations.length)
                {
                    //Show the no events alert
                    if(document.getElementById('no-event-alert'))
                    {
                        document.getElementById('no-event-alert').classList.remove('alert--active');
                    }
                }
                else
                {
                    //Show the no events alert
                    if(document.getElementById('no-event-alert'))
                    {
                        document.getElementById('no-event-alert').classList.add('alert--active');
                    }
                }
            }

            //Check if any events are returned
            if(eventLocations.length)
            {
                //Show listings section
                if(this.eventListingsWrapper)
                {
                    this.eventListingsWrapper.classList.remove('hidden');
                }


                //Show event details section
                if(this.eventDetailsWrapper)
                {
                    if(userClickedLocation)
                    {
                        this.eventDetailsWrapper.classList.remove('hidden');

                        if(this.backtoAllEventsWrapper)
                        {
                            this.backtoAllEventsWrapper.classList.remove('hidden');                        
                        }
                    }
                    else
                    {
                        this.eventDetailsWrapper.classList.add('hidden');

                        if(this.backtoAllEventsWrapper)
                        {
                            this.backtoAllEventsWrapper.classList.add('hidden');
                        }
                    }
                }


                //Hide listings 'no events' alert
                if(this.noEventListingsAlert)
                {
                    this.noEventListingsAlert.classList.add('hidden');
                }


                //Loop through locations
                let markers = eventLocations.map((event) =>
                {
                    if(event.name && event.lat && event.lng)
                    {
                        let markerLatLong = new google.maps.LatLng(event.lat, event.lng);

                        //Add marker to bounds to fit the map to all markers
                        bounds.extend(markerLatLong);


                        //Add the location postcode to eventLocationPostcodes
                        eventLocationPostcodes.push(event.postcode);


                        //Add the location product ids to eventLocationProductIds
                        for(let product_id of event.product_ids)
                        {
                            eventLocationProductIds.push(product_id);
                        }


                        //Set the 'distance from location' text for each location returned
                        let locationsDetailSection = document.querySelector('.event-details-section[data-postcode=\'' + event.postcode + '\'] .distance-from-location');
                        
                        if(locationsDetailSection)
                        {
                            locationsDetailSection.innerHTML = event.distance_from_user_location;
                        }


                        //Add the map marker
                        return this.addMarker(event, this.map, eventLocations.length);
                    }
                });


                //If one marker is returned
                if(eventLocations.length === 1)
                {
                    //Zoom the map out
                    this.map.setZoom(12);


                    //Center the map to the marker
                    if(markers[0])
                    {
                        this.map.setCenter(markers[0].getPosition());
                    }
                }
                else
                {
                    //Fit the map bounds to include all of the markers
                    this.map.fitBounds(bounds);
                }


                //Loop through event listings
                for(let eventListing of this.eventListings)
                {
                    //Hide location if they are not returned after a search
                    let eventListingPostcode = eventListing.getAttribute('data-postcode');

                    if(eventLocationPostcodes.includes(eventListingPostcode))
                    {
                        eventListing.classList.remove('listing--deactive');
                    }
                    else
                    {
                        eventListing.classList.add('listing--deactive');
                    }
                }


                //Loop through event detail sections (the listing per location)
                for(let eventDetailsListing of this.eventDetailsListings)
                {
                    //Hide location if they are not returned after a search
                    let eventDetailsPostcode = eventDetailsListing.getAttribute('data-postcode');

                    if(eventLocationPostcodes.includes(eventDetailsPostcode))
                    {
                        eventDetailsListing.classList.remove('hidden');


                        //Check the location listing for product listings (the products, i.e a session or holiday course)
                        if(eventDetailsListing.querySelectorAll('.listings .listing'))
                        {
                            //Loop through the products (events)
                            for(let eventDetailsListingProductListing of eventDetailsListing.querySelectorAll('.listings .listing'))
                            {

                                //Hide location if they are not returned after a search
                                let eventDetailsListingProductId = eventDetailsListingProductListing.getAttribute('data-product-id');


                                //Loop through event prices to set the correct price based on the users financial assistance status selected
                                if(eventDetailsListing.querySelectorAll('[data-price-fa-level]'))
                                {
                                    for(let eventPrice of eventDetailsListing.querySelectorAll('[data-price-fa-level]'))
                                    {
                                        //Hide all prices (only if a FA cookie is set)
                                        if(misc.getCookieValue('financial-assistance-level'))
                                        {
                                            eventPrice.classList.add('hidden');
            
                                            //Show the price that the users fa cookie is set to
                                            if(eventPrice.getAttribute('data-price-fa-level') === misc.getCookieValue('financial-assistance-level'))
                                            {
                                                eventPrice.classList.remove('hidden');
                                            }
                                        }
                                    }
                                }


                                //Show or hide the products depending on whether they exist in eventLocationProductIds (they have come back in the search, e.g. if a user searches an age range)
                                if(eventLocationProductIds.includes(parseInt(eventDetailsListingProductId)))
                                {
                                    eventDetailsListingProductListing.classList.remove('listing--deactive');
                                }
                                else
                                {
                                    eventDetailsListingProductListing.classList.add('listing--deactive');
                                }
                            }
                        }
                    }
                    else
                    {
                        eventDetailsListing.classList.add('hidden');
                    }
                }


                //Hide the list of locations and show the location details if the user has entered a location into the search
                if(userSearchedLocation)
                {
                    if(this.eventListingsWrapper)
                    {
                        this.eventListingsWrapper.classList.add('hidden');
                    }
                    if(this.eventListingsWrapper)
                    {
                        this.eventDetailsWrapper.classList.remove('hidden');

                        if(this.backtoAllEventsWrapper)
                        {
                            this.backtoAllEventsWrapper.classList.remove('hidden');
                        }
                    }
                }
            }
            else
            {
                if(this.eventDetailsWrapper)
                {
                    this.eventDetailsWrapper.classList.add('hidden');

                    if(this.backtoAllEventsWrapper)
                    {
                        this.backtoAllEventsWrapper.classList.add('hidden');
                    }
                }

                if(this.eventListingsWrapper)
                {
                    this.eventListingsWrapper.classList.add('hidden');
                }

                if(this.noEventListingsAlert)
                {
                    this.noEventListingsAlert.classList.remove('hidden');
                }
            }


            //When the map has finished loading, hide the loading overlay
            this.map.addListener('tilesloaded', ()=>
            {
                if(this.eventSearchOverlay)
                {
                    this.eventSearchOverlay.classList.remove('loading-overlay--active');
                }
            });
        },

        /*
        Convert the users searched location to a lat and lng, set hidden field values then run the map

        @param {String} location - the location entered by the user
        */
        convertSearchPostcodeToLatLng: function(postcode)
        {
            let geocoder = new google.maps.Geocoder();
        
            geocoder.geocode({address: postcode}, (results, status) =>
            {
                if(status == google.maps.GeocoderStatus.OK && results) 
                {
                    //Set the latitude hidden field value
                    if(document.getElementById('event-postcode-lat'))
                    {
                        document.getElementById('event-postcode-lat').value = results[0].geometry.location.lat();
                    }
                    
                    //Set the longitude hidden field value
                    if(document.getElementById('event-postcode-lng'))
                    {
                        document.getElementById('event-postcode-lng').value = results[0].geometry.location.lng();
                    }

                    //Run the map
                    this.initMap(false, '', true);
                    
                    //this.pushstateFormFieldData();
                }
                else
                {
                    this.eventSearchOverlay.classList.remove('loading-overlay--active');
                    alert('This location was not recognised. Please try entering a different location.');
                }
            });
        },
        /*
        Push the search form field values to the url
        */
        pushstateFormFieldData: function()
        {
            //Loop through the form fields, pushstate params to the url
            // let fields = this.eventSearchForm.querySelectorAll('select, input, textarea'),
            //     urlParams = '?';
            
            // for(let [i, field] of fields.entries())
            // {
            //     urlParams += i !== 0 ? '&' : '';
            //     urlParams += field.name + '=' + field.value;
            // }
            
            // window.history.pushState('', '', urlParams);
        },
        /*
        Grab data from json and build up an array of event locations

        @param {Object} params - the url params to pass to the endpoint
        */
        getEventLocationData: function(params)
        {
            let eventLocations = [];

            //Create a set of key/value pairs for fields in event search form. If no form exists, check if this is the saved events page. If so pass a param for that
            let endpointParams = this.eventSearchForm ? this.serializeForm(this.eventSearchForm) + (params ? params : '') : (params ? params : '');

            $.ajax({
                url: "/wp-json/wp/v2/event-locations?per_page=100" + (endpointParams ? '&' + endpointParams : ''),
                async: false,
                dataType: 'json',
                success: (json)=>
                {
                    eventLocations = json.locations ? json.locations : false;
                }
            });

            return eventLocations;
        },

        /*
        Serialize form data

        @param {Object} form - the form identifier
        */
        serializeForm: function(form)
        {
            let formData = new FormData(form),
                formDataParams = '',
                i = 0;

            for(let key of formData.keys())
            {
                formDataParams += (i !== 0 ? '&' : '') + (key + '=' + formData.get(key));

                i ++;
            }

            return formDataParams;
        },

        /*
        Add the marker, set the onclick event and return the marker at the end so it is returned for the marker clusterer plugin

        @param {Object} location - the location to add
        @param {Object} map - the google map to add it to
        */
        addMarker: function(location, map, mapMarkerCount)
        {
            this.icon = {
                scaledSize: new google.maps.Size(40, 40),
                size: new google.maps.Size(40, 40),
                url: '/wp-content/themes/bloomsburyfb/images/svgs/map-marker.svg'
            };

            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(location.lat, location.lng),
                icon: this.icon,
                title: location.name ? location.name : '',
                animation: google.maps.Animation.DROP,
                map: map
            });


            //If theres are more than one marker (we don't need to return this marker on the map only as that's the current state)
            if(mapMarkerCount > 1)
            {
                //On click of a marker
                marker.addListener("click", () =>
                {
                    if(location.postcode)
                    {
                        this.selectLocation(location.postcode);
                    }
                });
            }
            else
            {
                //On click of a marker
                marker.addListener("click", () =>
                {
                    var infoWindowContent = '<div class="tooltip-content tooltip-content--event row">';
                        infoWindowContent += location.image_url ? '<div class="col col--5"> \
                        <div class="tooltip-content__image" style="background-image: url(\'' + location.image_url + '\');"></div> \
                    </div>' : '';
                        infoWindowContent += '<div class="tooltip-content__content col col--7">';
                            infoWindowContent += location.name ? '<p class="tooltip-content__content__title">' + location.name + '</h5>' : '';
                            infoWindowContent += location.address ? '<p class="tooltip-content__content__text">' + location.address + '</p>' : '';
                        infoWindowContent += '</div>';
                    infoWindowContent += '</div>';

                    this.infowindow.setContent(infoWindowContent);

                    this.infowindow.open(map, marker);
                });
            }

            return marker;
        },

        /*
        Inits the map, passing the locations postcode in order to return this locations marker on the map only

        @param {String} postcode - the locations postcode
        */
        selectLocation: function(postcode)
        {
            //Set the hidden 'selected event location postcode' field value to this postcode, to be used to pass into getting events on click of a location...seperate from when the user enters a postcode in the search field which then gets the lat and lng for that location
            document.getElementById('selected-event-location-postcode').value = postcode;
            
            this.initMap(false, '&postcode=' + postcode, false, true);

            //Hide the list of locations
            this.eventListingsWrapper.classList.add('hidden');

            //Show the locations details section, so the locations detail section is shown
            // this.eventDetailsWrapper.classList.remove('hidden');
        }
    };

    accordion.init();
    animation.init();
    coachPortal.init();
    carousel.init();
    eventMapSearch.init();
    form.init();
    header.init();
    misc.init();
    modal.init();

}());
